import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { MatDialog, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SafeResourceUrl } from '@angular/platform-browser';
import * as moment from 'moment';
import * as countries from '../../../../shared/enums/countries.enum';
import * as enumProvincias from '../../../../shared/enums/provincias.enum';
import * as enumIncidencias from '../../../../shared/enums/tiposIncidencias.enum';
import * as enumTiposRetencion from '../../../../shared/enums/tiposRetencion.enum';
import * as enumTiposFactura from '../../../../shared/enums/tiposFacturas.enum';
import { InvoiceService } from '../../../../core/services/invoice.service';
import { Document, Invoice } from 'src/app/models/invoice';
import { AuthService } from '../../../../core/services/auth.service';
import { PwaService } from '../../../../core/services/pwa.service';
import { User } from '../../../../models/user';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/helpers/date-formats';
import { ValidadoresService } from '../../../../core/services/validadores.service';
import { OverviewDialogComponent } from '../overview-dialog/overview-dialog.component';
import { Company } from 'src/app/models/company';
import { combineLatest } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ListaFiltroSecunPrin } from 'src/app/models/listaFiltroSecunPrin';
import { Terceros } from 'src/app/models/tercero';
import { ObservacionesSecundario } from 'src/app/models/observacionesSecundario';
import { UsuarioDIEZdesplegable } from 'src/app/models/usuariosDIEZdesplegable';


registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@Component({
  selector: 'app-invoicer-reactivo',
  templateUrl: './invoicer-reactivo.component.html',
  styleUrls: ['./invoicer-reactivo.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class InvoicerReactivoComponent implements OnInit {

  private storageKey = 'sdmInvoicerCurrentUser';
  cargaTotalInvoicer: boolean = false;
  formulario: FormGroup;
  formChecksIncidencias: FormGroup;
  invoiceTipoFactura = [];
  invoicePais = [];
  invoiceTipoRetencion = [];
  formFiltroGetNext: FormGroup;
  listafiltroNextESTADO = [];
  listafiltroNextTIPO = [];
  listaFiltroUsuariosSUPER = [];
  listafiltroNextUSUARIOS: ListaFiltroSecunPrin[] = [];
  formIncidencias: FormGroup;
  invoiceFormBUSCADOREMP: FormGroup;
  promptEvent: Event;
  document: Document;
  invoice: Invoice;
  loading = false;
  saving = false;
  tiposDeIncidencias: enumIncidencias.TipoDeIncidencia[];
  paisesAsociadosCP: enumProvincias.iProvincia[];
  tiposDeRetencion: enumTiposRetencion.iTiposRetencion[];
  tiposDeFacturasRecibidas: enumTiposFactura.iTipoFactura[];
  tiposDeFacturasEmitidas: enumTiposFactura.iTipoFactura[];
  paisesCodigo: countries.iPaisesCodigo[];
  numeroDocumentosConNIFactualConDatos: number = -1;
  numeroDocumentosConNIFactualConDatosPendientes: number = -1;
  fechaHoy: number;
  currentUser: User;
  images: SafeResourceUrl[];
  invoiceUrl: SafeResourceUrl;
  viewerConfig: any;
  preguntaSepararRealizada = false;
  loadingNextInvoice = true;
  noInvoice = false;
  idTipoIncidencia: number;
  nombreUserPrincipal = '';
  nombreUserSecundario = '';
  nifCifClienteProveedor = '';
  nombreClienteProveedor = '';
  tiempoDesdeSubida = '';
  mostrarTodo = false;
  numeroDePaginasAlert = false;
  ////////////////////////////////////
  //PARA TIEMPOS DE GRABADO Y REVISION
  timeToSave: number;
  ////////////////////////////////////
  comentariosDeCliente = "";
  ObservacionCLIENTE: string = "";
  ObservacionSUPER: string;
  esEmpresaDeCanarias = false;
  usuarioQueProcesoFactura = "vacia";
  ID_documentonuevo = null;
  defaultValue: number;
  valorCP = '';
  _valorNIF = '';
  _valorTotalFactura = '';
  checkDesgloseActivo = false;
  checkDatosCPActivo = false;
  pasandoNEXT = false;
  bloqueadoRojo = false;
  revisionVerde = false;
  vieneDeListadoRevision = false;
  seHaAvisadoDeNumFactDUPLICADArevisando = false;
  predictionCifPropio = "";
  predictionCifPropioEncontrado = true;
  ////////////////////////////
  //CONTADORES
  pendientesDigitalizar = 0;
  pendientesSupervisar = 0;
  pendienteRevisar = 0;
  //////////////////////////////
  fechaMecanFactura = '';
  fechaMecanFacturaPropia = '';
  enRevisionModalExisteFactura: boolean = false;
  paginaCargada = document;
  mostrarListadoDocs = false;
  opcionIncidencia: string;
  IncidenciaAREA: string;
  seHaMostrandoAviso = false;
  aplicarColorROJO = false;
  separando = false;
  listadoEmpresas = [];
  ListaEmpresasGenerada = false;
  //FILTRO GET NEXT
  valorEstadoNEXT: number = 1;
  valorTipoNEXT: number = 1;
  valorSecPrinNEXT: string = "vacio";
  filtroEstado: number;
  filtroTipo: number;
  filtroCIF: string;
  filtroFecha: string;
  filtroUsuSUPER: number = 0;
  /////////////////////////////////////
  IDincidenciaPorModal: number = 0;
  esDocDeTercero: boolean = false;
  objetoTercero: Terceros = null;
  listadoTerceros: string[] = [];
  ////////////////////////////////////
  observacionSecundario: string = "";
  almacenarObservacionTemp: string = "";

  constructor(
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private dialog: MatDialog,
    private pwaService: PwaService,
    private adapter: DateAdapter<any>,
    private validadores: ValidadoresService
  ) {

    //Enums
    this.paisesCodigo = countries.paisesCodigo;
    this.paisesAsociadosCP = enumProvincias.provincias;
    this.tiposDeIncidencias = enumIncidencias.TiposDeIncidenciasEnum;
    this.tiposDeRetencion = enumTiposRetencion.TiposDeRetencion;
    this.tiposDeFacturasEmitidas = enumTiposFactura.TiposDeFacturasEmitidas;
    this.tiposDeFacturasRecibidas = enumTiposFactura.TiposDeFacturasRecibidas;

    //Filtro nextInvoice
    this.listafiltroNextUSUARIOS = [];
    var valorVacio: ListaFiltroSecunPrin = {
      secunPrin: "",
      fecha: 0,
      hora: 0
    };
    this.listafiltroNextUSUARIOS.push(valorVacio);
    this.filtroTipo = 0;
    this.filtroEstado = 0; //Pendientes
    this.filtroCIF = "";
    this.filtroFecha = "";

    //Funcionalidad
    this.currentUser = this.authService.currentUserValue;
    this.promptEvent = this.pwaService.promptEvent;
    this.adapter.setLocale('es');
    this.images = [];
    this.viewerConfig = {
      btnClass: 'default', // The CSS class(es) that will apply to the buttons
      zoomFactor: 0.1, // The amount that the scale will be increased by
      containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
      wheelZoom: true, // If true, the mouse wheel can be used to zoom in
      allowFullscreen: false, // If true, the fullscreen button will be shown, allowing the user to entr fullscreen mode
      allowKeyboardNavigation: true, // If true, the left / right arrow keys can be used for navigation
      btnIcons: { // The icon classes that will apply to the buttons. By default, font-awesome is used.
        zoomIn: 'fa fa-plus',
        zoomOut: 'fa fa-minus',
        rotateClockwise: 'fa fa-repeat',
        rotateCounterClockwise: 'fa fa-undo',
        next: 'fa fa-arrow-right',
        prev: 'fa fa-arrow-left',
        fullscreen: 'fa fa-arrows-alt',
      },
      btnShow: {
        zoomIn: true,
        zoomOut: true,
        rotateClockwise: false,
        rotateCounterClockwise: false,
        next: false,
        prev: false
      }
    };


    //FUNCIONES INICIALES
    this.crearFormularios();
  }

  ngOnInit() {
    //Para terceros...
    this.esDocDeTercero = false;
    this.objetoTercero = null;
    this.listadoTerceros = [];

    //Reset de variables de edición de documentos (si accedemos desde el listado)
    this.defaultValue = 1;
    this.bloqueadoRojo = false;
    this.revisionVerde = false;
    this.aplicarColorROJO = false;
    this.mostrarListadoDocs = false;
    this.ID_documentonuevo = null;

    let fecha: Date = new Date();
    let dia = fecha.getDate();
    let mes = fecha.getMonth() + 1;
    let ano = fecha.getFullYear();
    this.fechaHoy = ano * 10000 + mes * 100 + dia;
    this.preguntaSepararRealizada = false;
    this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;

    this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
  }

  ////////////////////////////
  //VALIDADORES Y GETTERS HTML

  get cifNoValido() {
    return this.formulario.get('invoiceCIF').invalid /*&& this.formulario.get('invoiceCIF').touched*/;
  }

  get numeroFacturaNoValido() {
    return this.formulario.get('invoiceNumber').invalid /*&& this.formulario.get('invoiceNumber').touched*/;
  }

  get fechaNoValida() {
    return this.formulario.get('invoiceDate').invalid /*&& this.formulario.get('invoiceDate').touched*/;
  }

  get nombreClienteProveedorNoValido() {
    return this.formulario.get('invoiceName').invalid /*&& this.formulario.get('invoiceName').touched*/;
  }

  get mailNoValido() {
    return this.formulario.get('invoiceMail').invalid /*&& this.formulario.get('invoiceMail').touched*/;
  }

  get cpNoValido() {

    return this.formulario.get('invoiceCodigoPostal').invalid /*&& this.formulario.get('invoiceCodigoPostal').touched*/;
  }

  get numeroFacturaMaxLength() {

    var control: string = this.formulario.get('invoiceNumber').value;

    if (control) {
      if (control.length > 30) {
        return true;
      }
    }


    return false;
  }

  /////////////////////////////////////////
  //GETTERS SELECT INPUTS

  getTiposFactura() {

    var lista = [];

    if (this.document.tipoDocumento == 1) {

      for (var i = 0; i < this.tiposDeFacturasEmitidas.length; i++) {

        var objeto = this.tiposDeFacturasEmitidas[i];
        lista.push(objeto)
      }

      return lista;
    }

    for (var i = 0; i < this.tiposDeFacturasRecibidas.length; i++) {

      var objeto = this.tiposDeFacturasRecibidas[i];
      lista.push(objeto)
    }

    return lista;
  }

  getPaises() {

    var lista = [];

    for (var i = 0; i < this.paisesCodigo.length; i++) {

      var objeto = this.paisesCodigo[i];
      lista.push(objeto);
    }

    return lista;
  }

  getTipoRetenciones() {

    var lista = [];

    for (var i = 0; i < this.tiposDeRetencion.length; i++) {

      var objeto = this.tiposDeRetencion[i];

      lista.push(objeto);
    }

    return lista;
  }

  getOpcionesEstadoFILTROnext() {

    if (this.currentUser.supervisor == true) {

      return [
        { posicion: 1, valuePos: 'Pendientes' },
        { posicion: 2, valuePos: 'Supervisar' }
      ];
    }

    return [
      { posicion: 1, valuePos: 'Pendientes' }
    ];
  }

  getOpcionesTipoFILTROnext() {

    return [
      {
        posicion: 1,
        valuePos: "Todos"
      },
      {
        posicion: 2,
        valuePos: "Emitidas"
      },
      {
        posicion: 3,
        valuePos: "Recibidas"
      }
    ];
  }

  //////////////////////////////////////////
  //CREACION DE FORMULARIOS, SUBMITS, EVENTLISTENERS, ...

  crearFormularios() {
    var dataAjustes = JSON.parse(localStorage.getItem(this.storageKey));

    this.formChecksIncidencias = this.fb.group({
      checkNoFactura: [false],
      checkSinNif: [false],
      checkFacturaIncompleta: [false],
      checkRevisarImportes: [false],
      checkRevisarNumFact: [false],
      checkNoIdentClienteProveedor: [false],
      checkRevisarFecha: [false],
      checkRevisarTipoFactura: [false],
      checkNoEuro: [false]
    });

    this.formFiltroGetNext = this.fb.group({
      listafiltroNextESTADO: [''],
      listafiltroNextTIPO: [''],
      listafiltroNextUSUARIOS: [''],
      filtroFechaSubida: [''],
      filtroNextNIF: [''],
      filtroUsuariosSUPER: ['']
    });

    ////////////////////////
    //Si el usuario del invoicer tiene asignado un cliente en campo 'FacturasCliente' de fichero 'AccesoUsuarios', solo cargarán facturas de dicho cliente...
    //console.warn(this.currentUser);

    if (this.currentUser.facturasCliente != null && this.currentUser.facturasCliente != "" && this.currentUser.facturasCliente != " ") {
      var value = this.currentUser.facturasCliente;
      this.valorSecPrinNEXT = value;

      this.formFiltroGetNext.patchValue({
        listafiltroNextUSUARIOS: value
      });
      this.formFiltroGetNext.get("listafiltroNextUSUARIOS").disable();
    }

    this.listafiltroNextESTADO = this.getOpcionesEstadoFILTROnext();
    this.listafiltroNextTIPO = this.getOpcionesTipoFILTROnext();

    this.formIncidencias = this.fb.group({
      invoiceAvisoInc: [''],
      invoiceAvisoIncAREA: ['']
    });

    this.invoiceFormBUSCADOREMP = this.fb.group({
      invoiceBuscadorEMP: ['']
    });

    this.formulario = this.fb.group({
      //Primer fila
      invoiceCIF: ['', [Validators.required, this.validadores.customerCifAdecuado]],
      invoiceEsTicket: [''],
      invoiceNumber: ['', [Validators.required, Validators.maxLength(30), this.validadores.numeroFacturaAdecuado]],
      invoiceDate: ['', [Validators.required, this.validadores.fechaNoAdecuada]],
      //Segunda fila
      invoiceTipoFactura: [''],
      invoiceName: ['', [Validators.required, this.validadores.cistomerNameAdecuado]],
      invoiceNameCom: [''],
      //Tercera fila
      invoiceMail: ['', [Validators.maxLength(60), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      invoiceDireccion: [''],
      invoiceCodigoPostal: ['', [Validators.maxLength(5)]],
      invoicePoblacion: [''],
      //Cuarta fila
      invoiceProvincia: [''],
      invoicePais: [''],
      invoiceTelefono: [''],
      invoiceTotal: [''],
      invoiceSuplidos: [''],
      //Quinta fila --> CUENTAS Y VALORES
      imponibles: this.fb.group({
        invoiceBase1: [''],
        invoicePorIva1: [''],
        invoiceCuotaIva1: [''],
        invoicePorRecargo1: [''],
        invoiceCuotaRecargo1: [''],
        invoiceBase2: [''],
        invoicePorIva2: [''],
        invoiceCuotaIva2: [''],
        invoicePorRecargo2: [''],
        invoiceCuotaRecargo2: [''],
        invoiceBase3: [''],
        invoicePorIva3: [''],
        invoiceCuotaIva3: [''],
        invoicePorRecargo3: [''],
        invoiceCuotaRecargo3: [''],
        invoiceBase4: [''],
        invoicePorIva4: [''],
        invoiceCuotaIva4: [''],
        invoicePorRecargo4: [''],
        invoiceCuotaRecargo4: [''],
        invoiceBase5: [''],
        invoicePorIva5: [''],
        invoiceCuotaIva5: [''],
        invoicePorRecargo5: [''],
        invoiceCuotaRecargo5: [''],
        invoiceBase6: [''],
        invoicePorIva6: [''],
        invoiceCuotaIva6: [''],
        invoicePorRecargo6: [''],
        invoiceCuotaRecargo6: [''],
      }),
      //RETENCIONES
      retenciones: this.fb.group({
        invoiceBaseRetencion: [''],
        invoicePorRetencion: [''],
        invoiceCuotaRetencion: [''],
        invoiceTipoRetencion: [''],
      }),
      //OBSERVACIONES
      invoiceObsCLIENTE: [''],
      invoiceObsSUPER: [''],
      invoiceObsINTER: ['']
    });

    this.invoicePais = this.getPaises();
    this.invoiceTipoRetencion = this.getTipoRetenciones();

    this.invoiceService.obtenerUsuariosDeGrupo(dataAjustes.grupo).subscribe(resultado => {
      this.listaFiltroUsuariosSUPER = resultado;

      var usuarioDefecto: UsuarioDIEZdesplegable = {
        id: 0,
        nombreEmail: "Sin especificar"
      };
      this.listaFiltroUsuariosSUPER.push(usuarioDefecto);

      this.listaFiltroUsuariosSUPER = this.listaFiltroUsuariosSUPER
        .sort(function (a, b) {
          if (b.id > a.id) { return -1; }
          if (b.id < a.id) { return 1; }
          return 0;
        });

    }, error => {
      this.toastr.error('Error en la obtención de usuarios DIEZ de mi grupo');
      this.listaFiltroUsuariosSUPER = [];
      console.log(error);
    });
  }

  quitarContabilizada() {
    this.document.url = '';
    this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
  }

  guardar(opcion: boolean = false) {

    let grabarFactura: boolean = true;

    console.warn("MOSTRANDO RESULTADOS FORMULARIO---> ");
    console.log(this.formulario);

    //Se ha seleccionado como incidencia la factura: 'No es una factura' o 'Factura incompleta'
    //Se omite chequeo...
    if (this.idTipoIncidencia == 100 || this.idTipoIncidencia == 4 || this.formChecksIncidencias.value["checkFacturaIncompleta"] == true) {

      this.SaveInvoice(opcion);
      return;
    }

    //Mientras el formulario no pase las validaciones de cada campo, este va a aparecer con la propiedad INVALID y no se podra guardar/actualizar...
    if (this.seHaMostrandoAviso == false && this.formulario.invalid) {

      if (this.seHaMostrandoAviso == false && this.GetFechaInteger(this.DevolverValorCeldaString('invoiceDate')) > this.fechaHoy) {

        const botonModal = document.getElementById("botonModal") as HTMLElement;
        botonModal.click();
        return;
      }

      return Object.values(this.formulario.controls).forEach(control => {

        //Control de errores con validadores PERSONALIZADOS...
        if (control.errors) {
          console.warn("ERROR --> ");
          console.warn(control.errors);

          if (this.seHaMostrandoAviso == false && (control.errors.fechaNoExistente == true || control.errors.numeroFactNoExiste == true || control.errors.cifCustomerNoExiste == true ||
            control.errors.nombreCustomerNoExiste == true
          )) {

            const botonModal = document.getElementById("botonModal") as HTMLElement;
            botonModal.click();
            return;
          }

          if (control.errors.totalFacturaIgual0 == true) {

            grabarFactura = false;
            const dialogRef = this.dialog.open(OverviewDialogComponent, {
              width: '750px',
              data: { title: 'Total 0 €', question: 'El total de la factura es de 0,00 €. ¿Desea grabar la factura de todas maneras?' }
            });

            dialogRef.afterClosed().subscribe(result => {
              console.log('The dialog was closed');
              if (result === 'No') {
                return;
              }

              this.SaveInvoice(opcion);
            }, error => {
              console.log(error);
            });
          }

          if (grabarFactura == false) {
            return;
          }

        }

        if (control instanceof FormGroup) {

          Object.values(control.controls).forEach(control => { control.markAsTouched() })

        } else {

          control.markAsTouched();
        }

      });
    }

    //////////////////////////////////////////////
    ////Si el formulario pasa las validaciones, se lanza la funcion de guardado/actualizacion...

    let baseRet: number = this.DevolverValorCeldaNumber('invoiceBaseRetencion', "retenciones");
    let porRet: number = this.DevolverValorCeldaNumber('invoicePorRetencion', "retenciones");
    let cuotaRet: number = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");
    let tipoRet: number = this.DevolverValorCeldaNumber('invoiceTipoRetencion', "retenciones");

    if (tipoRet != 0 && (baseRet == 0 || cuotaRet == 0 || porRet == 0)) {
      this.toastr.error("Rellena retencion");
      return;
    }

    if (tipoRet == 0 && (baseRet != 0 || cuotaRet != 0 || porRet != 0)) {
      this.toastr.error("Selecciona el tipo de retención.");
      return;
    }

    if (baseRet != 0 && (cuotaRet == 0 || porRet == 0)) {
      this.toastr.error("Rellena retencion");
      return;
    }

    if (cuotaRet != 0 && (baseRet == 0 || porRet == 0)) {
      this.toastr.error("Rellena retencion");
      return;
    }

    let totalFactura: number = this.DevolverValorCeldaNumber('invoiceTotal', "");
    let suplidos: number = this.DevolverValorCeldaNumber('invoiceSuplidos', "");
    let bases: Array<number> = [0, 0, 0, 0, 0, 0];
    let porIva: Array<number> = [0, 0, 0, 0, 0, 0];
    let cuotasIva: Array<number> = [0, 0, 0, 0, 0, 0];
    let porRecargo: Array<number> = [0, 0, 0, 0, 0, 0];
    let cuotasRecargo: Array<number> = [0, 0, 0, 0, 0, 0];

    for (var i = 1; i < 7; i++) {
      bases[i - 1] = this.DevolverValorCeldaNumber('invoiceBase' + i.toString(), "imponibles");
      porIva[i - 1] = this.DevolverValorCeldaNumber('invoicePorIva' + i.toString(), "imponibles");
      cuotasIva[i - 1] = this.DevolverValorCeldaNumber('invoiceCuotaIva' + i.toString(), "imponibles");
      porRecargo[i - 1] = this.DevolverValorCeldaNumber('invoicePorRecargo' + i.toString(), "imponibles");
      cuotasRecargo[i - 1] = this.DevolverValorCeldaNumber('invoiceCuotaRecargo' + i.toString(), "imponibles");
    }

    let tiposDeIvaPermitido: number[] = [0, 2, 4, 7.5, 10, 10.5, 21, 0.7, 1.5, 3, 7, 9.5, 15, 20, 6.5, 12, 22, 20, 5.5, 23, 19, 6, 9, 25, 13.5, 3, 17, 24, 14, 5];

    //Revisar los % de IVA
    for (var i = 1; i < 7; i++) {
      if (bases[i - 1] != 0) {
        if (tiposDeIvaPermitido.includes(porIva[i - 1]) == false) {
          this.toastr.error("Revisa los % de I.V.A.");
          return;
        }
      }
    }

    const tipoDeFacturaSelecc = parseInt(this.formulario.get('invoiceTipoFactura').value);
    var textoMensaje: string = '';
    let sumaCifras = Number(0);

    for (var i = 0; i < 5; i++) {
      sumaCifras = sumaCifras + (bases[i]);
    }

    sumaCifras = this.redondearExp(sumaCifras, 2);

    //Es recibida e "Inversión en sujeto pasivo"...
    if (this.document.tipoDocumento == 2 && (tipoDeFacturaSelecc == 8 || tipoDeFacturaSelecc == 9)) {

      if (totalFactura == sumaCifras) { //Si la suma de las bases es distinta al total...

        this.SaveInvoice(opcion);
        return;
      }

      textoMensaje = 'La suma de las bases (' + sumaCifras + ' €) no coincide con el total (' + totalFactura + ' €). ¿Desea grabar la factura de todas maneras?';

    }

    if (tipoDeFacturaSelecc == 1 || tipoDeFacturaSelecc == 4 || tipoDeFacturaSelecc >= 7) {
      for (var i = 0; i < 6; i++) {
        sumaCifras = sumaCifras + (cuotasIva[i] + cuotasRecargo[i]);
      }
    }

    sumaCifras = this.redondearExp(sumaCifras - cuotaRet + suplidos, 2);

    if (totalFactura != sumaCifras) {
      grabarFactura = false;

      textoMensaje = 'La suma de las bases y las cuotas (' + sumaCifras + ' €) no coincide con el total (' + totalFactura + ' €). ¿Desea grabar la factura de todas maneras?';

      const dialogRef = this.dialog.open(OverviewDialogComponent, {
        width: '750px',
        data: { title: 'El Total y las líneas no coinciden', question: textoMensaje }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        if (result === 'No') {
          return;
        }

        this.SaveInvoice(opcion);
      }, error => {
        console.log(error);
      });
    }

    if (grabarFactura == false) {
      return;
    }

    this.SaveInvoice(opcion);
  }

  clickContinuar() {
    this.seHaMostrandoAviso = true;

    if (this.revisionVerde == false && this.aplicarColorROJO == false) {
      this.guardar();
      return;
    }

    if (this.revisionVerde == true || this.aplicarColorROJO == true) {
      this.guardar(true);
      return;
    }
  }

  private SaveInvoice(revisando: boolean, idDocumento: number = 0) {


    this.seHaMostrandoAviso = false;
    let invoice: Invoice = new Invoice();
    invoice.id = this.document.id;

    if (idDocumento != 0) {
      invoice.id = idDocumento;
    }

    invoice.nif = this.DevolverValorCeldaString('invoiceCIF').trim();
    invoice.numeroFactura = this.DevolverValorCeldaString('invoiceNumber').trim();
    invoice.fecha = this.GetFechaInteger(this.DevolverValorCeldaString('invoiceDate'));
    invoice.totalFactura = this.DevolverValorCeldaNumber('invoiceTotal', "");
    invoice.baseImponible1 = this.DevolverValorCeldaNumber('invoiceBase1', "imponibles");
    invoice.baseImponible2 = this.DevolverValorCeldaNumber('invoiceBase2', "imponibles");
    invoice.baseImponible3 = this.DevolverValorCeldaNumber('invoiceBase3', "imponibles");
    invoice.baseImponible4 = this.DevolverValorCeldaNumber('invoiceBase4', "imponibles");
    invoice.baseImponible5 = this.DevolverValorCeldaNumber('invoiceBase5', "imponibles");
    invoice.baseImponible6 = this.DevolverValorCeldaNumber('invoiceBase6', "imponibles");
    invoice.porIva1 = this.DevolverValorCeldaNumber('invoicePorIva1', "imponibles");
    invoice.porIva2 = this.DevolverValorCeldaNumber('invoicePorIva2', "imponibles");
    invoice.porIva3 = this.DevolverValorCeldaNumber('invoicePorIva3', "imponibles");
    invoice.porIva4 = this.DevolverValorCeldaNumber('invoicePorIva4', "imponibles");
    invoice.porIva5 = this.DevolverValorCeldaNumber('invoicePorIva5', "imponibles");
    invoice.porIva6 = this.DevolverValorCeldaNumber('invoicePorIva6', "imponibles");
    invoice.cuotaIva1 = this.DevolverValorCeldaNumber('invoiceCuotaIva1', "imponibles");
    invoice.cuotaIva2 = this.DevolverValorCeldaNumber('invoiceCuotaIva2', "imponibles");
    invoice.cuotaIva3 = this.DevolverValorCeldaNumber('invoiceCuotaIva3', "imponibles");
    invoice.cuotaIva4 = this.DevolverValorCeldaNumber('invoiceCuotaIva4', "imponibles");
    invoice.cuotaIva5 = this.DevolverValorCeldaNumber('invoiceCuotaIva5', "imponibles");
    invoice.cuotaIva6 = this.DevolverValorCeldaNumber('invoiceCuotaIva6', "imponibles");
    invoice.porRecargo1 = this.DevolverValorCeldaNumber('invoicePorRecargo1', "imponibles");
    invoice.porRecargo2 = this.DevolverValorCeldaNumber('invoicePorRecargo2', "imponibles");
    invoice.porRecargo3 = this.DevolverValorCeldaNumber('invoicePorRecargo3', "imponibles");
    invoice.porRecargo4 = this.DevolverValorCeldaNumber('invoicePorRecargo4', "imponibles");
    invoice.porRecargo5 = this.DevolverValorCeldaNumber('invoicePorRecargo5', "imponibles");
    invoice.porRecargo6 = this.DevolverValorCeldaNumber('invoicePorRecargo6', "imponibles");
    invoice.cuotaRecargo1 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo1', "imponibles");
    invoice.cuotaRecargo2 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo2', "imponibles");
    invoice.cuotaRecargo3 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo3', "imponibles");
    invoice.cuotaRecargo4 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo4', "imponibles");
    invoice.cuotaRecargo5 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo5', "imponibles");
    invoice.cuotaRecargo6 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo6', "imponibles");
    invoice.suplidos = this.DevolverValorCeldaNumber('invoiceSuplidos', "");
    invoice.baseRetencion = this.DevolverValorCeldaNumber('invoiceBaseRetencion', "retenciones");
    invoice.porRetencion = this.DevolverValorCeldaNumber('invoicePorRetencion', "retenciones");
    invoice.cuotaRetencion = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");
    invoice.tipoRetencion = this.DevolverValorCeldaNumber('invoiceTipoRetencion', "retenciones");

    if (invoice.porRetencion != 0 && (invoice.baseRetencion == 0 && invoice.cuotaRetencion == 0)) {
      invoice.porRetencion = 0;
    }
    if (invoice.porIva1 != 0 && (invoice.baseImponible1 == 0 && invoice.cuotaIva1 == 0)) {
      invoice.porIva1 = 0;
    }
    if (invoice.porIva2 != 0 && (invoice.baseImponible2 == 0 && invoice.cuotaIva2 == 0)) {
      invoice.porIva2 = 0;
    }
    if (invoice.porIva3 != 0 && (invoice.baseImponible3 == 0 && invoice.cuotaIva3 == 0)) {
      invoice.porIva3 = 0;
    }
    if (invoice.porIva4 != 0 && (invoice.baseImponible4 == 0 && invoice.cuotaIva4 == 0)) {
      invoice.porIva4 = 0;
    }
    if (invoice.porIva5 != 0 && (invoice.baseImponible5 == 0 && invoice.cuotaIva5 == 0)) {
      invoice.porIva5 = 0;
    }
    if (invoice.porIva6 != 0 && (invoice.baseImponible6 == 0 && invoice.cuotaIva6 == 0)) {
      invoice.porIva6 = 0;
    }
    if (invoice.porRecargo1 != 0 && (invoice.baseImponible1 == 0 && invoice.cuotaRecargo1 == 0)) {
      invoice.porRecargo1 = 0;
    }
    if (invoice.porRecargo2 != 0 && (invoice.baseImponible2 == 0 && invoice.cuotaRecargo2 == 0)) {
      invoice.porRecargo2 = 0;
    }
    if (invoice.porRecargo3 != 0 && (invoice.baseImponible3 == 0 && invoice.cuotaRecargo3 == 0)) {
      invoice.porRecargo3 = 0;
    }
    if (invoice.porRecargo4 != 0 && (invoice.baseImponible4 == 0 && invoice.cuotaRecargo4 == 0)) {
      invoice.porRecargo4 = 0;
    }
    if (invoice.porRecargo5 != 0 && (invoice.baseImponible5 == 0 && invoice.cuotaRecargo5 == 0)) {
      invoice.porRecargo5 = 0;
    }
    if (invoice.porRecargo6 != 0 && (invoice.baseImponible6 == 0 && invoice.cuotaRecargo6 == 0)) {
      invoice.porRecargo6 = 0;
    }

    invoice.observaciones = this.DevolverValorCeldaString('invoiceObsCLIENTE').toUpperCase();
    invoice.idTipoIncidencia = this.idTipoIncidencia;
    invoice.observacionesSUPER = this.DevolverValorCeldaString('invoiceObsSUPER').trim();
    invoice.noDatosCP = false;
    if (this.formulario.get('invoiceEsTicket').value != null) {
      invoice.noDatosCP = this.formulario.get('invoiceEsTicket').value;
    }

    invoice.noDesgloseIva = false;
    invoice.noDatosCP = !!this.formulario.get('invoiceEsTicket').value;
    invoice.nombre = (this.DevolverValorCeldaString('invoiceName').trim().length > 0) ? this.DevolverValorCeldaString('invoiceName').trim().toUpperCase() : this.DevolverValorCeldaString('invoiceName').trim();
    invoice.nombreComercial = (this.DevolverValorCeldaString('invoiceNameCom').trim().length > 0) ? this.DevolverValorCeldaString('invoiceNameCom').trim().toUpperCase() : this.DevolverValorCeldaString('invoiceNameCom').trim();
    invoice.direccion = (this.DevolverValorCeldaString('invoiceDireccion').trim().length > 0) ? this.DevolverValorCeldaString('invoiceDireccion').trim().toUpperCase() : this.DevolverValorCeldaString('invoiceDireccion').trim();
    invoice.codigoPostal = this.DevolverValorCeldaNumber('invoiceCodigoPostal', "");
    invoice.poblacion = this.DevolverValorCeldaString('invoicePoblacion').trim();
    invoice.provincia = this.DevolverValorCeldaString('invoiceProvincia').trim();
    invoice.telefono = this.DevolverValorCeldaString('invoiceTelefono').trim();
    invoice.pais = this.DevolverValorCeldaString('invoicePais').trim();
    invoice.codigoPais = this.DevolverValorCeldaString('invoicePais').trim();
    invoice.email = this.DevolverValorCeldaString('invoiceMail').trim();
    invoice.tipoFactura = this.DevolverValorCeldaNumber('invoiceTipoFactura', "");
    invoice.tiempo = Date.now() - this.timeToSave;
    invoice.idUsuario = this.currentUser.id;

    //Grabar.
    this.saving = true;

    if (revisando == false) {

      this.invoiceService.postInvoice(invoice, this.DevolverValorCeldaString('invoiceObsINTER').trim()).subscribe(invoice => {
        this.saving = false;

        if (invoice.id == 0) {

          this.toastr.success('Factura grabada con éxito!');
          this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;

          this.invoiceService.pasarDocuConDatosAsupervision(this.document.id).subscribe(resultado => {
            this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
          }, error => {
            console.log(error);
            this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
          });

          return;
        }

        this.toastr.success('Factura grabada con éxito!');


        if (invoice.nif != "") {

          const companyToSave: Company = {
            id: this.DevolverValorStringNormalizado(invoice.nif).toUpperCase(),
            nombre: this.DevolverValorStringNormalizado(invoice.nombre).toUpperCase(),
            nComercial: this.DevolverValorStringNormalizado(invoice.nombreComercial).toUpperCase(),
            domicilio: this.DevolverValorStringNormalizado(invoice.direccion).toUpperCase(),
            codigoPostal: this.DevolverValorStringNormalizado(invoice.codigoPostal.toString()),
            poblacion: this.DevolverValorStringNormalizado(invoice.poblacion).toUpperCase(),
            provincia: this.DevolverValorStringNormalizado(invoice.provincia).toUpperCase(),
            pais: this.DevolverValorStringNormalizado(invoice.pais),
            telefono: this.DevolverValorStringNormalizado(invoice.telefono),
            email: this.DevolverValorStringNormalizado(invoice.email),
            cnae: '',
            fax: '',
            web: '',
            formaJuridica: '',
            estaEnNuestraBD: true,
            canarias: false,
            observaciones: ''
          };

          //Se actualizan o crean datos de empresa en nuestras tablas...
          this.invoiceService.SaveOrUpdateDatosEmpresa(companyToSave).subscribe((respuesta) => { }, (error) => {
            this.toastr.error("Error al actualizar los datos de la empresa en la base de datos");
            console.log(error);
          });
        }

        ///////////////////////////////////////////////////////////////
        //si no es una incidencia, lanzar envio de update a Invofox...
        // if (invoice.idTipoIncidencia == 0 || invoice.idTipoIncidencia == null) {

        //   //ENVIO UPDATE INVOFOX
        //   this.invoiceService.UpdateInvofoxDOC(invoice.id).subscribe(resultado => {

        //     //this.toastr.info("Enviando datos a Update de InvoFox...");
        //     console.log("************************************************");
        //     console.log("RESULTADO UPDATE INVOFOX -TRUE-");
        //     console.log(resultado);
        //     console.log("************************************************");

        //   }, error => {
        //     // this.toastr.error("Error al enviar los datos a Update de InvoFox");
        //     console.log("************************************************");
        //     console.log("RESULTADO UPDATE INVOFOX -FALSE-");
        //     console.warn(error);
        //     console.log("************************************************");
        //   });
        // }

        this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
        this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);


      }, error => {
        this.saving = false;
        this.toastr.error(error);
      }
      );

    } else {

      let esSupervisor: boolean = false;

      if (this.currentUser.supervisor == true) {
        esSupervisor = true;
      }

      invoice.usuarioQueLaRegistro = this.usuarioQueProcesoFactura;
      //para datos de tiempo de revision...
      invoice.quienRevisa = this.currentUser.email;
      invoice.tiempoRevision = Date.now() - this.timeToSave;

      this.invoiceService.updateDatosDocProcesado(esSupervisor, invoice, this.DevolverValorCeldaString('invoiceObsINTER').trim(), revisando)
        .subscribe(respuestaUpdate => {
          this.saving = false;

          this.toastr.success('Factura actualizada con éxito!');

          if (invoice.nif != "") {

            const companyToSave: Company = {
              id: this.DevolverValorStringNormalizado(invoice.nif).toUpperCase(),
              nombre: this.DevolverValorStringNormalizado(invoice.nombre).toUpperCase(),
              nComercial: this.DevolverValorStringNormalizado(invoice.nombreComercial).toUpperCase(),
              domicilio: this.DevolverValorStringNormalizado(invoice.direccion).toUpperCase(),
              codigoPostal: this.DevolverValorStringNormalizado(invoice.codigoPostal.toString()),
              poblacion: this.DevolverValorStringNormalizado(invoice.poblacion).toUpperCase(),
              provincia: this.DevolverValorStringNormalizado(invoice.provincia).toUpperCase(),
              pais: this.DevolverValorStringNormalizado(invoice.pais),
              telefono: this.DevolverValorStringNormalizado(invoice.telefono),
              email: this.DevolverValorStringNormalizado(invoice.email),
              cnae: '',
              fax: '',
              web: '',
              formaJuridica: '',
              estaEnNuestraBD: true,
              canarias: false,
              observaciones: ''
            };

            //Se actualizan o crean datos de empresa en nuestras tablas...
            this.invoiceService.SaveOrUpdateDatosEmpresa(companyToSave).subscribe((respuesta) => { }, (error) => {
              this.toastr.error("Error al actualizar los datos de la empresa en la base de datos");
              console.log(error);
            });

            ///////////////////////////////////////////////////////////////
            //si no es una incidencia, lanzar envio de update a Invofox...
            // if (invoice.idTipoIncidencia == 0 || invoice.idTipoIncidencia == null) {


            //   //ENVIO UPDATE INVOFOX
            //   this.invoiceService.UpdateInvofoxDOC(invoice.id).subscribe(resultado => {

            //     //this.toastr.info("Enviando datos a Update de InvoFox...");
            //     console.log("************************************************");
            //     console.log("RESULTADO UPDATE INVOFOX -TRUE-");
            //     console.log(resultado);
            //     console.log("************************************************");

            //   }, error => {
            //     // this.toastr.error("Error al enviar los datos a Update de InvoFox");
            //     console.log("************************************************");
            //     console.log("RESULTADO UPDATE INVOFOX -FALSE-");
            //     console.warn(error);
            //     console.log("************************************************");
            //   });
            // }
          }

          this.irSiguienteDespuesEdit();
        }, error => {
          this.saving = false;
          this.toastr.error(error);
        }
        );
    }
  }

  OnRevisar(sacarMensaje: boolean = true) {

    let nifCif: string = this.DevolverValorCeldaString('invoiceCIF').trim();
    let numeroFactura: string = this.DevolverValorCeldaString('invoiceNumber').trim();
    let fechaFactura: number = this.GetFechaInteger(this.DevolverValorCeldaString('invoiceDate').trim());

    if ((this.document.tipoDocumento == 1 && numeroFactura == "") || (this.document.tipoDocumento == 2 && (nifCif == "" || numeroFactura == ""))) {
      this.guardar(true);
      return;
    }

    if (sacarMensaje == false) {
      this.guardar(true);
      return;
    }

    if (this.document.tipoDocumento == 1 && nifCif == "") {
      nifCif = "NOSIRVE"; //En el caso de las facturas emitidas el nif del cliente es irrelevante.
    }

    try {
      numeroFactura = btoa(numeroFactura);

      this.invoiceService.existeFacturaIntroducidaDeClienteProveedor(true, this.document.secundario, this.document.tipoDocumento, nifCif, numeroFactura, this.document.id, fechaFactura)
        .subscribe(datosDocMec => {

          if (datosDocMec == null) {
            this.guardar(true);
            return;
          }

          if (datosDocMec != null) {

            this.fechaMecanFactura = this.SetFechaString(datosDocMec.fechaRevision);
            this.fechaMecanFacturaPropia = this.SetFechaString(datosDocMec.fecha);
            this.enRevisionModalExisteFactura = true;

            const botonModalExisteFactura = document.getElementById("botonModalExisteFactura") as HTMLElement;
            botonModalExisteFactura.click();

            //Se registra la incidencia de factura duplicada automaticamente...
            this.registrarIncidencia('8');

          } else {

            //Se limpian incidencias de duplicado u otras existentes...
            this.registrarIncidencia('0');
          }
        },
          error => {
            //this.cerrarLoader();
            console.log(error);
            this.toastr.error(error);
          });
    } catch (e) {
      this.toastr.error('Simbología no aceptada introducida en el Nº de factura.');
      this.cerrarLoader();
      this.guardar(true);
      return;
    }
  }

  pasarARevision() {

    if (this.document) {

      this.saving = true;

      this.invoiceService.EnviarARevision(this.document.id).subscribe((resp) => {

        this.saving = false;

        if (resp == false) {
          this.toastr.error("Error al enviar el documento a revisión");
          return;
        }
        this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
        this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);

      }, (error) => {
        console.log(error);
        this.saving = false;
        this.toastr.error("Error al enviar el documento a revisión");
      });
    }

  }

  irSiguienteDespuesEdit() {

    this.defaultValue = 1;

    this.bloqueadoRojo = false;
    this.revisionVerde = false;
    this.aplicarColorROJO = false;
    this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
    this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);

    this.mostrarListadoDocs = false;
    this.ID_documentonuevo = null;
  }

  resetearFormulario() {
    this.formulario.reset();
    this.formulario.patchValue({
      invoiceTipoFactura: 1
    });
    this.formChecksIncidencias.reset();
    this.formIncidencias.reset();
    this.idTipoIncidencia = 0;
  }

  //////////////////////////////////////////
  //*FUNCIONES GetNextINVOICE

  cerrarLoader() {

    setTimeout(() => {
      const botonPOPUP_loader = document.getElementById("botonLOADERnextCLOSE") as HTMLElement;
      botonPOPUP_loader.click();
    }, 600);
  }

  abrirLoader() {
    const botn_loader = document.getElementById("botonLOADERnext") as HTMLElement;
    botn_loader.click();
  }

  getNextInvoice(valorEstadoNEXT: number, valorSecPrinNEXT: string, valorTipoNEXT: number, valorFiltroCIF: string, valorFechaFiltro: string, filtroUsuSUPER: number) {

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {
        //Se continua con el proceso de carga...
        //////////////////////////////////////////////////////////////////////////////////////
        //PARA MODAL DE CARGA...
        this.abrirLoader();

        this.formChecksIncidencias.patchValue({
          checkNoFactura: false,
          checkSinNif: false,
          checkFacturaIncompleta: false,
          checkRevisarImportes: false,
          checkRevisarNumFact: false,
          checkNoIdentClienteProveedor: false,
          checkRevisarFecha: false,
          checkRevisarTipoFactura: false,
          checkNoEuro: false
        });

        var fechaFiltro = 0;
        this.IDincidenciaPorModal = 0;
        this.numeroDocumentosConNIFactualConDatos = -1;
        this.numeroDocumentosConNIFactualConDatosPendientes = -1;

        this.InicializarVariablesGlobales();
        if (valorSecPrinNEXT == "") {
          valorSecPrinNEXT = "vacio";
        }
        this.listafiltroNextUSUARIOS = [];
        var valorVacio: ListaFiltroSecunPrin = {
          secunPrin: "",
          fecha: 0,
          hora: 0
        };
        this.listafiltroNextUSUARIOS.push(valorVacio);

        if (valorFechaFiltro != "" && valorFechaFiltro != null) {
          fechaFiltro = this.GetFechaInteger(valorFechaFiltro);
        }

        //console.log(this.currentUser);

        combineLatest([
          this.invoiceService.CargarListadoSecundariosPendientes(this.filtroTipo, this.filtroEstado, "")
            .pipe(catchError(err => {
              console.warn("ERROR");
              console.warn(err);
              this.toastr.error('Error al intentar cargar listado de secundarios pendientes');
              this.loadingNextInvoice = false;
              this.noInvoice = true;
              this.cargaCabeceraEnFalloNEXT();

              throw err;
            })),
          this.invoiceService.CargarListadoPrincipalesPendientes(this.filtroTipo, this.filtroEstado, "")
            .pipe(catchError(err => {
              console.warn("ERROR");
              console.warn(err);
              this.toastr.error('Error al intentar cargar listado de principales pendientes');
              this.loadingNextInvoice = false;
              this.noInvoice = true;
              this.cargaCabeceraEnFalloNEXT();

              throw err;
            })),
          this.invoiceService.getNextInvoice(this.currentUser.email, valorEstadoNEXT, valorSecPrinNEXT, valorTipoNEXT, fechaFiltro, filtroUsuSUPER, valorFiltroCIF)
            .pipe(catchError(err => {
              console.warn("ERROR");
              console.warn(err);
              //this.toastr.error('Error al intentar cargar el documento');
              this.loadingNextInvoice = false;
              this.noInvoice = true;
              this.cargaCabeceraEnFalloNEXT();
              this.cerrarLoader();

              throw err;
            })),
          this.invoiceService.obtenerContadores()
            .pipe(catchError(err => {
              console.warn("ERROR");
              console.warn(err);
              this.toastr.error('Error al intentar obtener el contadores');
              this.loadingNextInvoice = false;
              this.noInvoice = true;
              this.cargaCabeceraEnFalloNEXT();

              throw err;
            }))
        ]).subscribe(([secundarios, principales, nextInvoice, contadores]) => {

          //console.clear();
          console.warn("Factura cargada con éxito.");

          secundarios.forEach(element => {
            this.listafiltroNextUSUARIOS.push(element);
          });

          principales.forEach(element => {
            this.listafiltroNextUSUARIOS.push(element);
          });

          this.listafiltroNextUSUARIOS = this.listafiltroNextUSUARIOS
            .sort(function (a, b) {

              if (b.fecha > a.fecha) { return -1; }
              if (b.fecha < a.fecha) { return 1; }
              //Ordenamos por hora
              if (b.fecha == a.fecha) {

                if (b.hora > a.hora) { return -1; }
                if (b.hora < a.hora) { return 1; }

                if (b.hora == a.hora) {

                  return 0;
                }
              }
            });

          if (contadores != null) {

            this.pendientesDigitalizar = contadores.pendientes;
            this.pendientesSupervisar = contadores.supervisar;
            this.pendienteRevisar = contadores.revision;
          }

          ////////////////////////////////////////////////////
          //nextInvoice

          this.CargarDatosDocumentoLeido(nextInvoice);

        }, error => {
          console.log(error);
          //this.toastr.error('Error en carga: getNextInvoice. Leer consola de depuración para más detalles.');
          this.cerrarLoader();
        });
      }

    }, error => {
      console.log(error);
    });
  }

  cargaCabeceraEnFalloNEXT() {

    this.listafiltroNextUSUARIOS = [];
    var valorVacio: ListaFiltroSecunPrin = {
      secunPrin: "",
      fecha: 0,
      hora: 0
    };
    this.listafiltroNextUSUARIOS.push(valorVacio);

    combineLatest([
      this.invoiceService.CargarListadoSecundariosPendientes(this.filtroTipo, this.filtroEstado, "")
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          this.toastr.error('Error al intentar cargar listado de secundarios pendientes');
          this.cerrarLoader();

          throw err;
        })),
      this.invoiceService.CargarListadoPrincipalesPendientes(this.filtroTipo, this.filtroEstado, "")
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          this.toastr.error('Error al intentar cargar listado de principales pendientes');
          this.cerrarLoader();

          throw err;
        })),
      this.invoiceService.obtenerContadores()
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          this.toastr.error('Error al intentar obtener el contadores');
          this.cerrarLoader();

          throw err;
        }))
    ]).subscribe(([secundarios, principales, contadores]) => {

      secundarios.forEach(element => {
        this.listafiltroNextUSUARIOS.push(element);
      });
      principales.forEach(element => {
        this.listafiltroNextUSUARIOS.push(element);
      });

      this.listafiltroNextUSUARIOS = this.listafiltroNextUSUARIOS
        .sort(function (a, b) {

          if (b.fecha > a.fecha) { return -1; }
          if (b.fecha < a.fecha) { return 1; }
          //Ordenamos por hora
          if (b.fecha == a.fecha) {

            if (b.hora > a.hora) { return -1; }
            if (b.hora < a.hora) { return 1; }

            if (b.hora == a.hora) {
              return 0;
            }
          }
        });

      if (contadores != null) {

        this.pendientesDigitalizar = contadores.pendientes;
        this.pendientesSupervisar = contadores.supervisar;
        this.pendienteRevisar = contadores.revision;
      }

    }, error => {
      console.log(error);
      this.cerrarLoader();
    });
  }

  CargarDatosDocumentoLeido(documentRead: Document) {

    console.warn("Procediendo a carga de datos de la factura...");
    this.images = [];
    this.document = documentRead;
    console.log(this.document);
    this.cargarObservacionSecundario();

    /////////////////////
    //comprobamos si el documento cargado es un .tiff para así avisar de NO MARCAR COMO INCIDENCIA y pasar a revisión
    /////////////////////
    if (this.document.url.includes(".tif") == true || this.document.url.includes(".tiff") == true) {

      const botn_avisoTIFF = document.getElementById("botonAvisoTIFF") as HTMLElement;
      botn_avisoTIFF.click();
    }

    this.idTipoIncidencia = 0;
    this.invoiceTipoFactura = this.getTiposFactura();
    var numeroPaginas: number = (documentRead.numberOfPages != null) ? documentRead.numberOfPages : 0;
    this.numeroDePaginasAlert = false;
    this.invoiceUrl = this.document.url;
    this.timeToSave = Date.now();
    this.comentariosDeCliente = this.DevolverValorStringNormalizado(this.document.comentariosCliente);
    this.ObservacionCLIENTE = this.comentariosDeCliente.toUpperCase();
    if (this.ObservacionCLIENTE) { this.idTipoIncidencia = 50 };


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //Si el numero de paginas es 0, quiere decir que el campo en la tabla es NULL. Llamamos a servicio para comprobacion de paginas...
    if (numeroPaginas == 0) {

      this.invoiceService.comprobarPaginasAlCargar(this.document).subscribe(respuesta => {

        numeroPaginas = respuesta;
        console.log("Num paginas del doc: " + numeroPaginas);

        if (numeroPaginas > 1) {
          this.numeroDePaginasAlert = true;
          const botonPOPUP_PAGINAS = document.getElementById("botonPOPUP") as HTMLElement;
          botonPOPUP_PAGINAS.click();
        }

      }, error => {
        this.toastr.error("Error en comprobación de número de páginas del documento");
        console.log(error);
      });
    }

    this.nombreUserPrincipal = '';
    this.nombreUserSecundario = '';
    this.nifCifClienteProveedor = '';
    this.nombreClienteProveedor = '';
    this.tiempoDesdeSubida = '';
    this.mostrarTodo = false;

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //Carga de datos de la cabecera...
    this.CargaDatosCabecera();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //Carga de datos de prediccion...
    this.cargaDatosPredicciones();
  }

  CargaDatosCabecera() {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////FECHA Y HORA SUBIDA DOC
    var fechaSubidaDoc: string = this.document.fecha.toString();
    var horaSubidaDoc: string = this.document.hora.toString();
    if (horaSubidaDoc.length === 5) {
      horaSubidaDoc = '0' + horaSubidaDoc;
    }
    var stringAnio: string = fechaSubidaDoc.substring(0, 4);
    var stringMes: string = fechaSubidaDoc.substring(4, 6);
    var stringDia: string = fechaSubidaDoc.substring(6, 8);
    var stringHoras: string = horaSubidaDoc.substring(0, 2);
    var horasNumber: number = Number(stringHoras);
    stringHoras = horasNumber.toString();
    var stringMinutos: string = horaSubidaDoc.substring(2, 4);
    var stringSegundos: string = horaSubidaDoc.substring(4, 6);
    var fechaDoc = moment('' + stringAnio + '-' + stringMes + '-' + stringDia + ' ' + stringHoras + ':' + stringMinutos + ':' + stringSegundos + '', 'YYYY-MM-DD HH:mm:ss');
    var fechaActual = moment();
    var diferencia = moment.duration(fechaActual.diff(fechaDoc));
    var diferenciaDias: number = diferencia.days();
    var diferenciaHoras: number = diferencia.hours();
    var diferenciaMinutos: number = diferencia.minutes();
    if (!diferenciaDias) {
      diferenciaDias = 0;
    }
    if (!diferenciaHoras) {
      diferenciaHoras = 0;
    }
    if (!diferenciaMinutos) {
      diferenciaMinutos = 0;
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //Comprobación para la suma de horas segun dias transcurridos...
    var sumaHorasDias: number = 0;
    if (diferenciaDias != 0) {
      sumaHorasDias = diferenciaDias * 24;
    }
    this.tiempoDesdeSubida = '(' + (diferenciaHoras + sumaHorasDias) + 'h:' + diferenciaMinutos + 'm)';
    var horaSubidaDocNEW: string = this.document.hora.toString();
    if (horaSubidaDocNEW.length === 5) {
      horaSubidaDocNEW = '0' + horaSubidaDocNEW;
    }
    var stringHoras: string = horaSubidaDocNEW.substring(0, 2);
    var horasNumber: number = Number(stringHoras);
    stringHoras = horasNumber.toString();
    var stringMinutos: string = horaSubidaDocNEW.substring(2, 4);
    var stringSegundos: string = horaSubidaDocNEW.substring(4, 6)
    var hora_final: string = stringHoras + stringMinutos + stringSegundos;
    var hora_finalNUMBER: number = Number(hora_final);
    this.document.hora = hora_finalNUMBER;
    this.mostrarTodo = true;

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //comprobamos si el principal es tercero o no
    combineLatest([
      this.invoiceService.documentoDeTerceros(this.document.usuario)
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          this.toastr.error('Error al comprobar si el documento es de terceros');
          throw err;
        })),
      this.invoiceService.obtenerDatosCabeceraInit(this.document.secundario, this.document.usuario)
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          this.toastr.error('Error en carga de datos de cabecera invoicer');
          const focusElement = this.renderer.selectRootElement('#invoiceCIF');
          setTimeout(() => focusElement.focus(), 0);
          throw err;
        }))
    ]).subscribe(([datosTercero, datosCabecera]) => {

      /////////////////////////////////////////////////
      //Acciones datosCabecera
      this.nombreUserSecundario = datosCabecera.nombreSecundario;
      this.nombreUserPrincipal = datosCabecera.nombrePrincipal;
      this.nombreClienteProveedor = datosCabecera.nombreEmpresa;

      if (datosCabecera.canarias != null) {
        this.esEmpresaDeCanarias = datosCabecera.canarias;
      }

      this.esDocDeTercero = (datosTercero.tercero != null) ? true : false;
      this.objetoTercero = (datosTercero.tercero != null) ? datosTercero.tercero : null;
      this.listadoTerceros = datosTercero.todosTerceros;

      if (datosTercero.tercero != null) {
        this.nombreUserPrincipal = datosTercero.tercero.descripcion;
        this.nombreUserSecundario = '';
      }

      //PARA MODAL DE CARGA...
      this.cerrarLoader();
      this.loadingNextInvoice = false;

    }, error => {
      console.warn(error);
      this.cerrarLoader();
      this.loadingNextInvoice = false;
    });

    //SI ESTAMOS CARGANDO UN DOCUMENTO YA RELLENADO...
    if (this.document.estado > 1) {
      this.revisionVerde = true;
      this.usuarioQueProcesoFactura = this.document.usuarioQueLaRegistro;
      this.TraerDatosDoc(this.document.id);
      return;
    }

    //Añadimos el valor de tipo de factura 1 por defecto.
    this.formulario.patchValue({
      invoiceTipoFactura: 1
    });
  }

  cargaDatosPredicciones() {

    let varlorNifEncontrado: string = "";
    let nifVieneDePrediccionDatos: boolean = false;
    let existenPrediccionDatosEmpresa: boolean = false;

    //NO queremos que cargue la prediccion en documentos PROCESADOS, CONTABILIZADOS y PENDIENTES DE SUPERVISAR...
    if (this.document.estado != 2 && this.document.estado != 4 && this.document.estado != 20 && this.document.estado < 20000 && this.document.estado != 21) {

      //Hacemos la carga de las predicciones...
      this.invoiceService.obtenerDatosPredicciones(this.document.id).subscribe(resultado => {
        console.log("****************************************");
        console.log("Cargando resultado PREDICCIONES: ");
        console.log(resultado);
        console.log("****************************************");

        if (resultado) {
          //Carga de datos de predicción...
          if (resultado.prediction) {

            this.predictionCifPropio = resultado.prediction.cifPropio;
            this.predictionCifPropioEncontrado = resultado.prediction.cifPropioEncontrado;

            // if (this.nifCifClienteProveedor == "") {
            //   console.log("++++++++");
            //   console.log("Carga de cif con llamada a datos de cabecera VACIO. Usando cifpropio de predicciones...");
            //   console.log("++++++++");
            this.nifCifClienteProveedor = resultado.prediction.cifPropio;
            // }

            if (resultado.prediction.p1 >= 0.75) {
              varlorNifEncontrado = resultado.prediction.prediccion1;

            } else if (resultado.prediction.p2 >= 0.75) {
              varlorNifEncontrado = resultado.prediction.prediccion2;
            }

            if (varlorNifEncontrado == this.nifCifClienteProveedor) {
              varlorNifEncontrado = "";
            }

            //si InversiónSujetoPasivo está a true, sacar "Posible factura de Inversión en sujeto pasivo" en modal.
            if (resultado.prediction.inversionSujetoPasivo && resultado.prediction.inversionSujetoPasivo == true) {
              //PARA MODAL DE CARGA...
              const botonInversion = document.getElementById("botonInversion") as HTMLElement;
              botonInversion.click();
            }
          }

          if (resultado.predictionDatos == null && varlorNifEncontrado != "") {
            this.formulario.patchValue({
              invoiceCIF: varlorNifEncontrado
            });
          }

          //Los datos vienen de PredictionDatos (datos generados con entrenamiento de plantillas).........
          if (resultado.predictionDatos) {

            existenPrediccionDatosEmpresa = true;

            //Añadimos el valor de tipo de factura 1 por defecto si la predicción no nos trae el tipo de factura...
            this.formulario.patchValue({
              invoiceTipoFactura: (resultado.predictionDatos.tipoFactura != 1 && resultado.predictionDatos.tipoFactura != null) ? resultado.predictionDatos.tipoFactura : 1
            });

            if (this.document.tipoDocumento == 1) {
              if (resultado.predictionDatos.nif != null && resultado.predictionDatos.nif != "") {
                nifVieneDePrediccionDatos = true;
                varlorNifEncontrado = resultado.predictionDatos.nif
              }
            }

            this.formulario.patchValue({
              invoiceCIF: varlorNifEncontrado,
              invoiceNumber: this.DevolverValorStringNormalizado(resultado.predictionDatos.numeroFactura),
              invoiceDate: this.SetFechaString(resultado.predictionDatos.fecha),
              //Segunda fila
              invoiceName: (resultado.predictionDatos.nombre != null) ? resultado.predictionDatos.nombre.trim().toUpperCase() : "",
              //Tercera fila
              invoiceDireccion: (resultado.predictionDatos.direccion != null) ? resultado.predictionDatos.direccion.trim().toUpperCase() : "",
              invoiceCodigoPostal: (resultado.predictionDatos.codigoPostal == 0) ? '' : resultado.predictionDatos.codigoPostal.toString().padStart(5, "0"),
              invoicePoblacion: (resultado.predictionDatos.poblacion != null) ? resultado.predictionDatos.poblacion.trim().toUpperCase() : "",
              //Cuarta fila
              invoiceTotal: (resultado.predictionDatos.totalFactura == 0) ? '' : resultado.predictionDatos.totalFactura.toString(),
              //Quinta fila --> CUENTAS Y VALORES
              imponibles: {
                invoiceBase1: (resultado.predictionDatos.baseImponible1 == 0) ? '' : resultado.predictionDatos.baseImponible1,
                invoicePorIva1: (resultado.predictionDatos.porIva1 == 0) ? '' : resultado.predictionDatos.porIva1,
                invoiceCuotaIva1: (resultado.predictionDatos.cuotaIva1 == 0) ? '' : resultado.predictionDatos.cuotaIva1,
                invoicePorRecargo1: (resultado.predictionDatos.porRecargo1 == 0) ? '' : resultado.predictionDatos.porRecargo1,
                invoiceCuotaRecargo1: (resultado.predictionDatos.cuotaRecargo1 == 0) ? '' : resultado.predictionDatos.cuotaRecargo1,
                invoiceBase2: (resultado.predictionDatos.baseImponible2 == 0) ? '' : resultado.predictionDatos.baseImponible2,
                invoicePorIva2: (resultado.predictionDatos.porIva2 == 0) ? '' : resultado.predictionDatos.porIva2,
                invoiceCuotaIva2: (resultado.predictionDatos.cuotaIva2 == 0) ? '' : resultado.predictionDatos.cuotaIva2,
                invoicePorRecargo2: (resultado.predictionDatos.porRecargo2 == 0) ? '' : resultado.predictionDatos.porRecargo2,
                invoiceCuotaRecargo2: (resultado.predictionDatos.cuotaRecargo2 == 0) ? '' : resultado.predictionDatos.cuotaRecargo2,
                invoiceBase3: (resultado.predictionDatos.baseImponible3 == 0) ? '' : resultado.predictionDatos.baseImponible3,
                invoicePorIva3: (resultado.predictionDatos.porIva3 == 0) ? '' : resultado.predictionDatos.porIva3,
                invoiceCuotaIva3: (resultado.predictionDatos.cuotaIva3 == 0) ? '' : resultado.predictionDatos.cuotaIva3,
                invoicePorRecargo3: (resultado.predictionDatos.porRecargo3 == 0) ? '' : resultado.predictionDatos.porRecargo3,
                invoiceCuotaRecargo3: (resultado.predictionDatos.cuotaRecargo3 == 0) ? '' : resultado.predictionDatos.cuotaRecargo3,
                invoiceBase4: (resultado.predictionDatos.baseImponible4 == 0) ? '' : resultado.predictionDatos.baseImponible4,
                invoicePorIva4: (resultado.predictionDatos.porIva4 == 0) ? '' : resultado.predictionDatos.porIva4,
                invoiceCuotaIva4: (resultado.predictionDatos.cuotaIva4 == 0) ? '' : resultado.predictionDatos.cuotaIva4,
                invoicePorRecargo4: (resultado.predictionDatos.porRecargo4 == 0) ? '' : resultado.predictionDatos.porRecargo4,
                invoiceCuotaRecargo4: (resultado.predictionDatos.cuotaRecargo4 == 0) ? '' : resultado.predictionDatos.cuotaRecargo4,
                invoiceBase5: (resultado.predictionDatos.baseImponible5 == 0) ? '' : resultado.predictionDatos.baseImponible5,
                invoicePorIva5: (resultado.predictionDatos.porIva5 == 0) ? '' : resultado.predictionDatos.porIva5,
                invoiceCuotaIva5: (resultado.predictionDatos.cuotaIva5 == 0) ? '' : resultado.predictionDatos.cuotaIva5,
                invoicePorRecargo5: (resultado.predictionDatos.porRecargo5 == 0) ? '' : resultado.predictionDatos.porRecargo5,
                invoiceCuotaRecargo5: (resultado.predictionDatos.cuotaRecargo5 == 0) ? '' : resultado.predictionDatos.cuotaRecargo5,
                invoiceBase6: (resultado.predictionDatos.baseImponible6 == 0) ? '' : resultado.predictionDatos.baseImponible6,
                invoicePorIva6: (resultado.predictionDatos.porIva6 == 0) ? '' : resultado.predictionDatos.porIva6,
                invoiceCuotaIva6: (resultado.predictionDatos.cuotaIva6 == 0) ? '' : resultado.predictionDatos.cuotaIva6,
                invoicePorRecargo6: (resultado.predictionDatos.porRecargo6 == 0) ? '' : resultado.predictionDatos.porRecargo6,
                invoiceCuotaRecargo6: (resultado.predictionDatos.cuotaRecargo6 == 0) ? '' : resultado.predictionDatos.cuotaRecargo6,
              }
            });

            if (this.DevolverValorCeldaString('invoiceName') == '' && this.DevolverValorCeldaString('invoiceCodigoPostal') == '') {
              existenPrediccionDatosEmpresa = false;
            }

            this._valorTotalFactura = this.DevolverValorCeldaNumber("invoiceTotal", "").toString();

            if (this.DevolverValorCeldaString('invoiceDate') != "") {
              this.fechaChange(this.DevolverValorCeldaString('invoiceDate'), 1);
            }

            if (this.DevolverValorCeldaString('invoiceCodigoPostal') != "") {
              this.ponerProvincia(this.valorCP);
            }

            if ((this.document.tipoDocumento == 1 && this.DevolverValorCeldaString('invoiceNumber') != "") || (this.document.tipoDocumento == 2 && this.DevolverValorCeldaString('invoiceNumber') != "" && this.DevolverValorCeldaString('invoiceCIF') != "")) {

              this.existeFacturaYa(false, this.document.secundario, this.document.tipoDocumento, this.DevolverValorCeldaString('invoiceCIF'), this.DevolverValorCeldaString('invoiceNumber'));
            }
          }
        }

        //Obtenemos dato cargado en incoicer despues de las comprobaciones...
        let NifClienteProveedor = this.DevolverValorCeldaString('invoiceCIF');

        //Si tenemos un CIF en el campo del invoicer y NO existen datos de prediccion para ese CIF
        if (NifClienteProveedor != "" && (existenPrediccionDatosEmpresa == false || this.EsCif(NifClienteProveedor) == true)) {
          //this.toastr.info("Buscando datos del CIF " + NifClienteProveedor  + " en nuestras bases de datos...");
          this.cargaDatosProveedor(NifClienteProveedor, nifVieneDePrediccionDatos);
        }

        //ChequeoPlantilla...
        var nif: string = (this.document.tipoDocumento == 2) ? this.formulario.get('invoiceCIF').value : this.nifCifClienteProveedor;

        if (nif) {
          this.ObtenerNumeroFacturasNIF(nif, this.document.tipoDocumento);
          this.ObtenerNumeroFacturasPorNIFPendientes(nif, this.document.tipoDocumento, this.document.secundario);
        }

        if (this.predictionCifPropio == this.nifCifClienteProveedor) {
          if (this.predictionCifPropioEncontrado == false) {
            const botonModalNoCIFempresa = this.paginaCargada.getElementById("botonModalNoCIFempresa") as HTMLElement;
            botonModalNoCIFempresa.click();
          }
        }

        //PARA MODAL DE CARGA...
        this.cerrarLoader();
        this.loadingNextInvoice = false;

      }, error => {
        //this.toastr.error("No existe predicción de datos para este documento.");
        this.toastr.warning('No se han detectado datos de PREDICCIÓN para el documento');
        console.log(error);

        //PARA MODAL DE CARGA...
        this.cerrarLoader();
        this.loadingNextInvoice = false;
        throw error;
      });
    }
  }

  cargaDatosProveedor(NifClienteProveedor: string, nifVieneDePrediccionDatos: boolean) {

    //Ahora ejecutamos carga de datos del proveedor:
    combineLatest([
      this.invoiceService.getCompany(NifClienteProveedor)
        .pipe(catchError(err => {
          console.warn("ERROR en getCompany");
          console.warn(err);
          throw err;
        })),
      this.invoiceService.getDatosProveedor(NifClienteProveedor)
        .pipe(catchError(err => {
          console.warn("ERROR en getDatosProveedor");
          console.warn(err);
          throw err;
        }))
    ]).subscribe(([getCompany, getDatosProveedor]) => {

      /////////////////////////////////////////////
      //GetCompany
      console.log("VIENDO DATOS COMPAÑIA Y PROVEEDOR...");
      console.log("COMPAÑIA", getCompany);
      console.log("PROVEEDOR", getDatosProveedor);

      if (getCompany == null || getCompany.nombre == null) {

        //console.log(this.formulario.get('invoiceName').value);
        //console.log(nifVieneDePrediccionDatos);

        if (this.formulario.get('invoiceName').value == "" && nifVieneDePrediccionDatos == false) {
          //this.LimpiarCamposDatosClienteProveedor();

          var cadena: string = (this.document.tipoDocumento == 2) ? "PROVEEDOR" : "CLIENTE";

          this.toastr.info("¡CIF cargado desde la predicción! Comprueba que sea el correcto...", "¡COMPROBAR CIF " + cadena + "!");
          this.toastr.error("No se ha encontrado en nuestras bases de datos información de empresa asociada al CIF");
          this.loading = false;

          let focusElement = this.renderer.selectRootElement('#invoiceCIF');
          setTimeout(() => focusElement.focus(), 0);
        }
        if (nifVieneDePrediccionDatos == true) {
          this.loading = false;
          this.toastr.warning("No hay información del CIF en nuestra base de datos. Asignando desde predicción...");
        }
        return;
      }

      //this.toastr.success("¡Datos encontrados!");

      this.formulario.patchValue({
        invoiceName: getCompany.nombre,
        invoiceDireccion: getCompany.domicilio,
        invoiceNameCom: getCompany.nComercial,
        invoiceTelefono: getCompany.telefono,
        invoiceCodigoPostal: getCompany.codigoPostal,
        invoicePoblacion: getCompany.poblacion,
        invoiceProvincia: getCompany.provincia,
        invoicePais: getCompany.pais,
        invoiceMail: getCompany.email,
        invoiceObsINTER: getCompany.observaciones
      });

      if (getCompany.provincia != null && getCompany.provincia != "") {

        for (var i = 0; i < this.paisesAsociadosCP.length; i++) {
          if (getCompany.provincia == this.paisesAsociadosCP[i].Nombre) { //si ha traido una provincia que es española..
            this.formulario.patchValue({
              invoicePais: 'ES'
            });
          }
        }
      }

      this.bloqueadoRojo = false;

      if (getCompany.estaEnNuestraBD == false) {
        this.bloqueadoRojo = true;
      }

      /////////////////////////////////////////////
      //GetDatosProveedor

      if (this.esEmpresaDeCanarias == false) {

        if (getDatosProveedor == null) {
          this.toastr.error('No se encontraron datos de facturas anteriores con este proveedor');
          return;
        }

        if (getDatosProveedor.tipoFactura == 0) {
          getDatosProveedor.tipoFactura = 1;
        }

        this.formulario.patchValue({
          invoiceTipoFactura: (getDatosProveedor.tipoFactura == 8 || getDatosProveedor.tipoFactura == 9) ? 1 : getDatosProveedor.tipoFactura
        });

        if (this.DevolverValorCeldaNumber('invoiceTotal', "") == 0) {
          this.formulario.patchValue({
            imponibles: {
              invoicePorIva1: (this.DevolverValorCeldaNumber('invoicePorIva1', "imponibles") == 0) ? getDatosProveedor.porIva1 : this.DevolverValorCeldaNumber('invoicePorIva1', "imponibles"),
              invoicePorIva2: (this.DevolverValorCeldaNumber('invoicePorIva2', "imponibles") == 0) ? ((getDatosProveedor.porIva2 == 0) ? '' : getDatosProveedor.porIva2) : (this.DevolverValorCeldaNumber('invoicePorIva2', "imponibles") == 0),
              invoicePorIva3: (this.DevolverValorCeldaNumber('invoicePorIva3', "imponibles") == 0) ? ((getDatosProveedor.porIva3 == 0) ? '' : getDatosProveedor.porIva3) : (this.DevolverValorCeldaNumber('invoicePorIva3', "imponibles") == 0),
              invoicePorIva4: (this.DevolverValorCeldaNumber('invoicePorIva4', "imponibles") == 0) ? ((getDatosProveedor.porIva4 == 0) ? '' : getDatosProveedor.porIva4) : (this.DevolverValorCeldaNumber('invoicePorIva4', "imponibles") == 0),
              invoicePorIva5: (this.DevolverValorCeldaNumber('invoicePorIva5', "imponibles") == 0) ? ((getDatosProveedor.porIva5 == 0) ? '' : getDatosProveedor.porIva5) : (this.DevolverValorCeldaNumber('invoicePorIva5', "imponibles") == 0),
              // invoicePorIva6: (this.DevolverValorCeldaNumber('invoicePorIva6', "imponibles") == 0) ? ((getDatosProveedor.porIva6 == 0) ? '' : getDatosProveedor.porIva6) : (this.DevolverValorCeldaNumber('invoicePorIva6', "imponibles") == 0),
              // invoicePorIva7: (this.DevolverValorCeldaNumber('invoicePorIva7', "imponibles") == 0) ? ((getDatosProveedor.porIva7 == 0) ? '' : getDatosProveedor.porIva7) : (this.DevolverValorCeldaNumber('invoicePorIva7', "imponibles") == 0),
              // invoicePorIva8: (this.DevolverValorCeldaNumber('invoicePorIva8', "imponibles") == 0) ? ((getDatosProveedor.porIva8 == 0) ? '' : getDatosProveedor.porIva8) : (this.DevolverValorCeldaNumber('invoicePorIva8', "imponibles") == 0),
            },
            retenciones: {
              invoicePorRetencion: (getDatosProveedor.tipoRetencion > 0) ? getDatosProveedor.porRetencion.toString() : '',
              invoiceTipoRetencion: (getDatosProveedor.tipoRetencion > 0) ? getDatosProveedor.tipoRetencion : 0
            }
          });
        }
      }

      const focusElement = this.renderer.selectRootElement('#invoiceNumber');
      setTimeout(() => focusElement.focus(), 0);

      //ChequeoPlantilla...
      var nif: string = (this.document.tipoDocumento == 2) ? this.formulario.get('invoiceCIF').value : this.nifCifClienteProveedor;
      if (nif) {
        this.ObtenerNumeroFacturasNIF(nif, this.document.tipoDocumento);
        this.ObtenerNumeroFacturasPorNIFPendientes(nif, this.document.tipoDocumento, this.document.secundario);
      }

      this.loading = false;

    }, error => {
      console.log(error);
      this.loading = false;
      //this.toastr.error('Error en carga: cargaDatosProveedor. Leer consola de depuración para más detalles.');

      if (this.formulario.get('invoiceName').value == "" && nifVieneDePrediccionDatos == false) {
        this.formulario.patchValue({ invoiceName: '' });
        this.formulario.patchValue({ invoiceNameCom: '' });
        this.formulario.patchValue({ invoiceDireccion: '' });
        this.formulario.patchValue({ invoiceCodigoPostal: '' });
        this.formulario.patchValue({ invoicePoblacion: '' });
        this.formulario.patchValue({ invoiceProvincia: '' });
        this.formulario.patchValue({ invoicePais: '' });
        this.formulario.patchValue({ invoiceTelefono: '' });
        this.formulario.patchValue({ invoiceMail: '' });
        this.formulario.patchValue({ invoiceObsINTER: '' });
      }

      this.bloqueadoRojo = false;

      this.cerrarLoader();
      this.loadingNextInvoice = false;
    });
  }

  TraerDatosDoc(idDocumento) {

    this.invoiceService.obtenerDatosDocSelecc(idDocumento)
      .subscribe(documentData => {

        //RESET A VALOR POR DEFECTO DEL FORMULARIO...
        //this.resetearFormulario();

        this.ID_documentonuevo = documentData.datos.id;
        this.defaultValue = documentData.datos.tipoFactura;
        this.valorCP = this.LimpiarStringValorCero(documentData.datos.codigoPostal);

        this.idTipoIncidencia = documentData.datos.idTipoIncidencia;

        //Comprobar si la incidencia viene del combo.
        if (this.idTipoIncidencia > 0) {
          this.tiposDeIncidencias.forEach(element => {
            if (element.idInterno == this.idTipoIncidencia) {
              this.IDincidenciaPorModal = element.idInterno;
            }
          });
        }

        this.ObservacionCLIENTE = documentData.datos.observaciones;
        this.ObservacionSUPER = documentData.datos.observacionesSUPER;
        this._valorNIF = documentData.datos.nif;
        this._valorTotalFactura = (documentData.datos.totalFactura == 0) ? "" : documentData.datos.totalFactura.toString();
        this.checkDatosCPActivo = documentData.datos.noDatosCP;
        this.checkDesgloseActivo = documentData.datos.noDesgloseIva;

        //this.formulario.patchValue({invoiceObsINTER: documentData.observacionesINTERNAS});

        //Colocamos los datos en el formulario...
        this.formulario.setValue({

          invoiceCIF: documentData.datos.nif,
          invoiceEsTicket: this.checkDatosCPActivo,
          invoiceNumber: documentData.datos.numeroFactura,
          invoiceDate: this.SetFechaString(documentData.datos.fecha),
          invoiceTipoFactura: documentData.datos.tipoFactura,
          invoiceName: documentData.datos.nombre,
          invoiceNameCom: documentData.datos.nombreComercial,
          invoiceMail: documentData.datos.email,
          invoiceDireccion: documentData.datos.direccion,
          invoiceCodigoPostal: this.LimpiarStringValorCero(documentData.datos.codigoPostal),
          invoicePoblacion: documentData.datos.poblacion,
          invoiceProvincia: documentData.datos.provincia,
          invoicePais: documentData.datos.pais,
          invoiceTelefono: documentData.datos.telefono,
          invoiceTotal: (documentData.datos.totalFactura == 0) ? '' : documentData.datos.totalFactura.toString(),
          invoiceSuplidos: (documentData.datos.suplidos == 0) ? '' : documentData.datos.suplidos,
          imponibles: {
            invoiceBase1: (documentData.datos.baseImponible1 == 0) ? '' : documentData.datos.baseImponible1,
            invoicePorIva1: (documentData.datos.porIva1 == 0) ? '' : documentData.datos.porIva1,
            invoiceCuotaIva1: (documentData.datos.cuotaIva1 == 0) ? '' : documentData.datos.cuotaIva1,
            invoicePorRecargo1: (documentData.datos.porRecargo1 == 0) ? '' : documentData.datos.porRecargo1,
            invoiceCuotaRecargo1: (documentData.datos.cuotaRecargo1 == 0) ? '' : documentData.datos.cuotaRecargo1,
            invoiceBase2: (documentData.datos.baseImponible2 == 0) ? '' : documentData.datos.baseImponible2,
            invoicePorIva2: (documentData.datos.porIva2 == 0) ? '' : documentData.datos.porIva2,
            invoiceCuotaIva2: (documentData.datos.cuotaIva2 == 0) ? '' : documentData.datos.cuotaIva2,
            invoicePorRecargo2: (documentData.datos.porRecargo2 == 0) ? '' : documentData.datos.porRecargo2,
            invoiceCuotaRecargo2: (documentData.datos.cuotaRecargo2 == 0) ? '' : documentData.datos.cuotaRecargo2,
            invoiceBase3: (documentData.datos.baseImponible3 == 0) ? '' : documentData.datos.baseImponible3,
            invoicePorIva3: (documentData.datos.porIva3 == 0) ? '' : documentData.datos.porIva3,
            invoiceCuotaIva3: (documentData.datos.cuotaIva3 == 0) ? '' : documentData.datos.cuotaIva3,
            invoicePorRecargo3: (documentData.datos.porRecargo3 == 0) ? '' : documentData.datos.porRecargo3,
            invoiceCuotaRecargo3: (documentData.datos.cuotaRecargo3 == 0) ? '' : documentData.datos.cuotaRecargo3,
            invoiceBase4: (documentData.datos.baseImponible4 == 0) ? '' : documentData.datos.baseImponible4,
            invoicePorIva4: (documentData.datos.porIva4 == 0) ? '' : documentData.datos.porIva4,
            invoiceCuotaIva4: (documentData.datos.cuotaIva4 == 0) ? '' : documentData.datos.cuotaIva4,
            invoicePorRecargo4: (documentData.datos.porRecargo4 == 0) ? '' : documentData.datos.porRecargo4,
            invoiceCuotaRecargo4: (documentData.datos.cuotaRecargo4 == 0) ? '' : documentData.datos.cuotaRecargo4,
            invoiceBase5: (documentData.datos.baseImponible5 == 0) ? '' : documentData.datos.baseImponible5,
            invoicePorIva5: (documentData.datos.porIva5 == 0) ? '' : documentData.datos.porIva5,
            invoiceCuotaIva5: (documentData.datos.cuotaIva5 == 0) ? '' : documentData.datos.cuotaIva5,
            invoicePorRecargo5: (documentData.datos.porRecargo5 == 0) ? '' : documentData.datos.porRecargo5,
            invoiceCuotaRecargo5: (documentData.datos.cuotaRecargo5 == 0) ? '' : documentData.datos.cuotaRecargo5,
            invoiceBase6: (documentData.datos.baseImponible6 == 0) ? '' : documentData.datos.baseImponible6,
            invoicePorIva6: (documentData.datos.porIva6 == 0) ? '' : documentData.datos.porIva6,
            invoiceCuotaIva6: (documentData.datos.cuotaIva6 == 0) ? '' : documentData.datos.cuotaIva6,
            invoicePorRecargo6: (documentData.datos.porRecargo6 == 0) ? '' : documentData.datos.porRecargo6,
            invoiceCuotaRecargo6: (documentData.datos.cuotaRecargo6 == 0) ? '' : documentData.datos.cuotaRecargo6,
          },
          retenciones: {
            invoiceBaseRetencion: (documentData.datos.baseRetencion == 0) ? '' : documentData.datos.baseRetencion,
            invoicePorRetencion: (documentData.datos.porRetencion == 0) ? '' : documentData.datos.porRetencion,
            invoiceCuotaRetencion: (documentData.datos.cuotaRetencion == 0) ? '' : documentData.datos.cuotaRetencion,

            invoiceTipoRetencion: (documentData.datos.tipoRetencion == 0) ? '' : documentData.datos.tipoRetencion

          },
          invoiceObsCLIENTE: documentData.datos.observaciones,
          invoiceObsSUPER: documentData.datos.observacionesSUPER,
          invoiceObsINTER: documentData.observacionesInternas
        });



        this.invoiceService.obtenerEstadoDocPorID(documentData.datos.id).subscribe(estado => {
          if (estado == 20 || estado == 21) {
            this.aplicarColorROJO = false;

            this.invoiceService.cambiarAestadoRevisandoDesdeLista(documentData.datos.id).subscribe(respuesta => {
              this.revisionVerde = true;
            });
          }

          if (estado == 2) {
            this.revisionVerde = false;
            this.aplicarColorROJO = true;
          }
        }, error => {
          console.log(error);
        });

        //Revisión existencia de varias incidencias seleccionadas. Control de marcado de los nuevos 'checks rapidos'...
        if (this.ObservacionCLIENTE.length > 0) {

          if (this.ObservacionCLIENTE.includes("NO ES UNA FACTURA")) {
            this.formChecksIncidencias.patchValue({ checkNoFactura: true });
          }

          if (this.ObservacionCLIENTE.includes("SIN NIF CLIENTE o PROVEEDOR")) {
            this.formChecksIncidencias.patchValue({ checkSinNif: true });
          }

          if (this.ObservacionCLIENTE.includes("FACTURA INCOMPLETA")) {
            this.formChecksIncidencias.patchValue({ checkFacturaIncompleta: true });
          }

          if (this.ObservacionCLIENTE.includes("REVISAR IMPORTES")) {
            this.formChecksIncidencias.patchValue({ checkRevisarImportes: true });
          }

          if (this.ObservacionCLIENTE.includes("REVISAR NUMERO DE FACTURA")) {
            this.formChecksIncidencias.patchValue({ checkRevisarNumFact: true });
          }

          if (this.ObservacionCLIENTE.includes("NO ES POSIBLE IDENTIFICAR LA FECHA DE LA FACTURA")) {
            this.formChecksIncidencias.patchValue({ checkRevisarFecha: true });
          }

          if (this.ObservacionCLIENTE.includes("NO ES POSIBLE IDENTIFICAR EL CLIENTE O PROVEEDOR DE LA FACTURA")) {
            this.formChecksIncidencias.patchValue({ checkNoIdentClienteProveedor: true });
          }

          if (this.ObservacionCLIENTE.includes("REVISAR TIPO DE FACTURA")) {
            this.formChecksIncidencias.patchValue({ checkRevisarTipoFactura: true });
          }

          if (this.ObservacionCLIENTE.includes("IMPORTES EN UNA MONEDA DIFERENTE AL EURO")) {
            this.formChecksIncidencias.patchValue({ checkNoEuro: true });
          }
        }

      }, error => {

        //PARA MODAL DE CARGA...
        this.cerrarLoader();

        this.loadingNextInvoice = false;
        this.noInvoice = true;
        this.toastr.error(error);
      });
  }

  ObtenerNumeroFacturasNIF(nif: string, tipoDocumento: number) {

    nif = nif.toLocaleUpperCase();

    this.invoiceService.ObtenerNumeroFacturasPorNIF(nif, tipoDocumento).subscribe(datosRecibidos => {

      this.numeroDocumentosConNIFactualConDatos = datosRecibidos;
    }, error => {
      console.log(error);
    });
  }

  ObtenerNumeroFacturasPorNIFPendientes(nif: string, tipoDocumento: number, secundario: string) {

    nif = nif.toLocaleUpperCase();
    secundario = secundario.toLocaleUpperCase();

    this.invoiceService.ObtenerNumeroFacturasPorNIFPendientes(nif, tipoDocumento, secundario).subscribe(datosRecibidos => {

      this.numeroDocumentosConNIFactualConDatosPendientes = datosRecibidos;
    }, error => {
      console.log(error);
    })
  }

  pasarAsiguiente() {

    this.pasandoNEXT = true;

    if (this.document) {

      try {

        this.invoiceService.marcarDocumentoParaNEXT(this.document.id, this.usuarioQueProcesoFactura)
          .subscribe(resultado => {

            this.pasandoNEXT = false;
            this.filtroCIF = this.formFiltroGetNext.get('filtroNextNIF').value;
            this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
            this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);

          }, error => {
            this.pasandoNEXT = false;
            this.toastr.error(error);
          });

      } catch (e) {

        this.pasandoNEXT = false;
        //PARA MODAL DE CARGA...
        this.cerrarLoader();

        console.log(e);
        this.toastr.error('No se ha podido pasar a la siguiente factura pendiente.');
      }

    } else {
      //si no hay ninguna factura que saltar o devolver a su estado original... directamente hacer nextInvoice
      this.filtroCIF = this.formFiltroGetNext.get('filtroNextNIF').value;
      this.pasandoNEXT = false;
      this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
      this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
    }
  }

  cambiarGetNext($event: any, vieneDeEstado: boolean, vieneDeTipo: boolean, vieneDeSecun: boolean, vieneDeFecha: boolean, vieneDeUsuarioSUPER: boolean) {
    console.log("Alterando orden de entrada de facturas...");

    if (vieneDeSecun && vieneDeFecha) { //Si viene de cambiar filtro usando combo secun/prin - fecha...
      this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
      if (this.valorEstadoNEXT == 1) { this.revisionVerde = false; }
      if (this.valorEstadoNEXT == 20) { this.revisionVerde = true; }

      if (this.valorSecPrinNEXT != "vacio" && this.valorSecPrinNEXT != "") { //Si tenemos valor...
        this.valorSecPrinNEXT = this.valorSecPrinNEXT.toUpperCase();
      }
      try {
        this.pasarAsiguiente();
      } catch (e) {
        console.log(e);
      }

      return;
    }

    if (vieneDeEstado) {
      this.filtroEstado = $event.target.options.selectedIndex;

      if (this.filtroEstado == 0) { //pendientes

        this.revisionVerde = false;
        this.valorEstadoNEXT = 1;

        try {
          this.pasarAsiguiente();
        } catch (e) {
          console.log(e);
        }
      }

      if (this.filtroEstado == 1) { //Revisar

        this.revisionVerde = true;
        this.valorEstadoNEXT = 20;

        try {
          this.pasarAsiguiente();
        } catch (e) {
          console.log(e);
        }
      }
      return;
    }

    if (vieneDeTipo) {
      var filtro = $event.target.options.selectedIndex;
      if (this.filtroEstado == 0) { this.revisionVerde = false; }
      if (this.filtroEstado == 1) { this.revisionVerde = true; }


      if (filtro == 0) { //Todos

        this.valorTipoNEXT = 1;

        try {
          this.pasarAsiguiente();
        } catch (e) {
          console.log(e);
        }
      }

      if (filtro == 1) { //Emitidas

        this.valorTipoNEXT = 2;

        try {
          this.pasarAsiguiente();
        } catch (e) {
          console.log(e);
        }
      }

      if (filtro == 2) { //recibidas

        this.valorTipoNEXT = 3;

        try {
          this.pasarAsiguiente();
        } catch (e) {
          console.log(e);
        }
      }
      return;
    }

    if (vieneDeSecun == true) {
      if (this.valorEstadoNEXT == 1) { this.revisionVerde = false; }
      if (this.valorEstadoNEXT == 20) { this.revisionVerde = true; }
      this.valorSecPrinNEXT = $event.target.value;

      if (this.valorSecPrinNEXT != "vacio" && this.valorSecPrinNEXT != "") { //Si tenemos valor...
        this.valorSecPrinNEXT = this.valorSecPrinNEXT.toUpperCase();
      }

      try {
        this.pasarAsiguiente();
      } catch (e) {
        console.log(e);
      }

      return;
    }

    if (vieneDeFecha == true) {
      this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;

      this.pasarAsiguiente();

      return;
    }

    if (this.valorEstadoNEXT == 20 && vieneDeUsuarioSUPER == true) {
      console.log(this.formFiltroGetNext.get('filtroUsuariosSUPER').value);
      var paraCortar: string = this.formFiltroGetNext.get('filtroUsuariosSUPER').value;
      var corte: string[] = paraCortar.split(" -- ");
      console.log(corte);
      console.log(this.listaFiltroUsuariosSUPER);

      var valorFINAL = this.listaFiltroUsuariosSUPER.find(resultado => resultado.nombreEmail.split(" -- ")[1] == corte[1]);

      this.filtroUsuSUPER = valorFINAL.id;

      this.pasarAsiguiente();
    }
  }

  clickGetNextInvoice() {
    this.usuarioQueProcesoFactura = "vacia";
    this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
    this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
  }

  cargarSecundarioEnFiltro($event) {

    let secundarioSeleccionado: string = $event.target.options[$event.target.options.selectedIndex].value;
    var value = secundarioSeleccionado.trim().split(" - ");
    //console.log(value);

    this.formFiltroGetNext.patchValue({
      listafiltroNextUSUARIOS: value[0].trim(),
      filtroFechaSubida: value[1].trim()
    });
    this.valorSecPrinNEXT = value[0].trim();

    this.cambiarGetNext($event, false, false, true, true, false);
  }

  cargarDocumentoRecibidoDeHijo(idDocumentoACargar: number) {
    console.log("Cargando documento de id...", idDocumentoACargar);

    if (Number.isNaN(idDocumentoACargar) == true || idDocumentoACargar == undefined || idDocumentoACargar == null) {
      return;
    }

    //Primero se quita el estado en el documento actual.
    if (this.document != null) {

      this.invoiceService.marcarDocumentoParaNEXT(this.document.id, this.usuarioQueProcesoFactura).subscribe(documento => {

        //Luego se carga normalmente y dependiendo del estado se hace una cosa u otra.
        this.mostrarListadoDocs = false;
        this.InicializarVariablesGlobales();

        //PARA MODAL DE CARGA...
        this.abrirLoader();

        this.invoiceService.cargarDocSelecc(this.currentUser.email, idDocumentoACargar.toString()).subscribe(document => {

          //Si el documento no es un documento ya procesado, se quita el color rojo/verde que carga al actualizar procesados...
          if (document.estado != 2 && document.estado != 21) {

            this.bloqueadoRojo = false;
            this.aplicarColorROJO = false;
            this.revisionVerde = false;
          }

          this.CargarDatosDocumentoLeido(document);

        }, error => {
          this.loadingNextInvoice = false;
          this.noInvoice = true;
          this.toastr.error(error);
          this.cerrarLoader();
        });

        return;

      }, error => {
        this.toastr.error(error);
      });

    } else { //Si no hay ningun documento asignado, solo ejecutamos carga del nuevo...

      //Luego se carga normalmente y dependiendo del estado se hace una cosa u otra.
      this.mostrarListadoDocs = false;
      this.InicializarVariablesGlobales();

      //PARA MODAL DE CARGA...
      this.abrirLoader();

      this.invoiceService.cargarDocSelecc(this.currentUser.email, idDocumentoACargar.toString()).subscribe(document => {

        //Si el documento no es un documento ya procesado, se quita el color rojo/verde que carga al actualizar procesados...
        if (document.estado != 2 && document.estado != 21) {

          this.bloqueadoRojo = false;
          this.aplicarColorROJO = false;
          this.revisionVerde = false;
        }

        this.CargarDatosDocumentoLeido(document);

      }, error => {
        this.loadingNextInvoice = false;
        this.noInvoice = true;
        this.toastr.error(error);
        this.cerrarLoader();
      });
    }
  }

  //////////////////////////////////////////
  //FORMATEO DE INPUTS, VALORES, CADENAS, ...

  private InicializarVariablesGlobales() {
    this.formulario.reset();
    this.formChecksIncidencias.reset();
    this.bloqueadoRojo = false;
    this.revisionVerde = false;
    this.checkDesgloseActivo = false;
    this.checkDatosCPActivo = false;
    this.vieneDeListadoRevision = false;
    this.defaultValue = 1;
    this.loadingNextInvoice = true;
    this.document = null;
    this.noInvoice = false;
    this.comentariosDeCliente = "";
    this.formIncidencias.reset();
    this.seHaAvisadoDeNumFactDUPLICADArevisando = false;
    this.usuarioQueProcesoFactura = "vacia";
    this._valorNIF = '';
    this.predictionCifPropio = "";
    this.predictionCifPropioEncontrado = true;
    this.esEmpresaDeCanarias = false;
  }

  private inicializarBasesCuotas() {
    this.formulario.patchValue({
      imponibles: {
        invoiceBase1: undefined,
        invoiceCuotaIva1: undefined,
        invoicePorIva1: undefined,
        invoicePorRecargo1: undefined,
        invoiceCuotaRecargo1: undefined,
        invoiceBase2: undefined,
        invoiceCuotaIva2: undefined,
        invoicePorIva2: undefined,
        invoicePorRecargo2: undefined,
        invoiceCuotaRecargo2: undefined,
        invoiceBase3: undefined,
        invoiceCuotaIva3: undefined,
        invoicePorIva3: undefined,
        invoicePorRecargo3: undefined,
        invoiceCuotaRecargo3: undefined,
        invoiceBase4: undefined,
        invoiceCuotaIva4: undefined,
        invoicePorIva4: undefined,
        invoicePorRecargo4: undefined,
        invoiceCuotaRecargo4: undefined,
        invoiceBase5: undefined,
        invoiceCuotaIva5: undefined,
        invoicePorIva5: undefined,
        invoicePorRecargo5: undefined,
        invoiceCuotaRecargo5: undefined,
        invoiceBase6: undefined,
        invoiceCuotaIva6: undefined,
        invoicePorIva6: undefined,
        invoicePorRecargo6: undefined,
        invoiceCuotaRecargo6: undefined
      },
      retenciones: {
        invoiceBaseRetencion: undefined,
        invoicePorRetencion: undefined,
        invoiceCuotaRetencion: undefined,
        invoiceTipoRetencion: undefined
      }
    });
  }

  private isNotNumberAndText($event) {
    var codes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 113, 119, 101, 114, 116, 121, 117, 105, 111, 112, 97, 115, 100, 102, 103, 104, 106, 107, 108, 241, 122, 120, 99, 118, 98, 110, 109, 81, 87, 69, 82, 84, 89, 85, 73, 79, 80, 65, 83, 68, 70, 71, 72, 74, 75, 76, 209, 90, 88, 67, 86, 66, 78, 77];
    var charCode = $event.keyCode;


    if (codes.indexOf(charCode) == -1) {

      $event.preventDefault();

      return false;

    } else {

      return true;
    }
  }

  private DevolverValorStringNormalizado(valor: string): string {

    if (valor == null || valor == undefined) {
      return "";
    }

    return valor.trim();
  }

  private DevolverValorCeldaNumber(nombreCelda: string, grupo: string): number {
    let resultado = Number(0);

    if (grupo != "") {

      if (this.formulario.get(grupo).get(nombreCelda) == null) {
        console.log("Error - " + nombreCelda + ": campo Null");
      }
      else if (typeof (this.formulario.get(grupo).get(nombreCelda).value) === "string") {
        let value = this.formulario.get(grupo).get(nombreCelda).value;

        if (value && value.match(/\,/)) {
          value = value.replace(',', '.');
        }

        resultado = parseFloat(value);
      } else if (typeof (this.formulario.get(grupo).get(nombreCelda).value) === "number") {
        resultado = Number(this.formulario.get(grupo).get(nombreCelda).value);
      } else {
        resultado = Number(this.formulario.get(grupo).get(nombreCelda));
      }

      if (Number.isNaN(resultado) || resultado == undefined || resultado == null) {
        resultado = 0;
      }

      return resultado;
    }

    if (this.formulario.get(nombreCelda) == null) {
      console.log("Error - " + nombreCelda + ": campo Null");
    }
    else if (typeof (this.formulario.get(nombreCelda).value) === "string") {
      let value = this.formulario.get(nombreCelda).value;

      if (value && value.match(/\,/)) {
        value = value.replace(',', '.');
      }

      resultado = parseFloat(value);
    } else if (typeof (this.formulario.get(nombreCelda).value) === "number") {
      resultado = Number(this.formulario.get(nombreCelda).value);
    } else {
      resultado = Number(this.formulario.get(nombreCelda));
    }

    if (Number.isNaN(resultado) || resultado == undefined || resultado == null) {
      resultado = 0;
    }

    return resultado;
  }

  DevolverValorCeldaString(nombreCelda: string): string {
    let resultado: string = "";

    if (this.formulario.get(nombreCelda) == null) {
      console.log("Error - " + nombreCelda + ": campo Null");
    } else {
      resultado = this.formulario.get(nombreCelda).value;
    }

    if (!resultado) {
      resultado = "";
    }

    return resultado;
  }

  private DevolverValorCeldaBoolean(nombreCelda: string): boolean {
    let resultado: boolean = false;

    if (this.formulario.get(nombreCelda) == null) {
      console.log("Error - " + nombreCelda + ": campo Null");
    } else {
      resultado = this.formulario.get(nombreCelda).value;
    }

    if (!resultado) {
      resultado = false;
    }

    return resultado;
  }

  SetFechaString(date: number): string {
    let resultado: string = "";

    if (Number.isNaN(date) == true || date == undefined || date == null) {
      return "";
    }

    if (date == 0) {
      return "";
    }

    let dia: number = 0;
    let mes: number = 0;
    let ano: number = 0;

    ano = this.redondearExp(date / 10000, 0);
    date = date - (ano * 10000);
    mes = this.redondearExp(date / 100, 0);
    dia = date - (mes * 100);

    if (ano == 0 || mes == 0 || dia == 0) {
      return "";
    }

    resultado = dia.toString().padStart(2, "0") + "/" + mes.toString().padStart(2, "0") + "/" + ano.toString();

    return resultado;
  }

  private redondearExp(numero: number, digitos: number, masEspaciado: boolean = false): number {

    let absNumero = Math.abs(numero);
    let signo = Math.sign(numero);

    if (masEspaciado) {
      let n = Math.floor(Math.log2(absNumero));
      let spacing = Math.pow(2, n) * Number.EPSILON;
      if (spacing < Math.pow(10, -digitos - 1)) {
        absNumero += spacing;
      }
    }

    let entero = Math.round(this.toExp(absNumero, digitos));
    return signo * this.toExp(entero, -digitos);
  }

  private toExp(numero: Number, digitos: number): number {
    let arr = numero.toString().split("e");
    let mantisa = arr[0], exponente = digitos;
    if (arr[1]) exponente = Number(arr[1]) + digitos;
    return Number(mantisa + "e" + exponente.toString());
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  private getAmountValue(value: string): number {
    if (value && value.match(/\,/)) {
      value = value.replace(',', '.');
    }

    let newValue = parseFloat(value);
    if (isNaN(newValue)) {
      newValue = 0;
    }

    return newValue;
  }

  private LimpiarStringValorCero(valor: number): string {

    if (Number.isNaN(valor) == true || valor == undefined || valor == null) {
      return "";
    }

    if (valor == 0) {
      return "";
    }

    return valor.toString();
  }

  saltarCamposLlenos(vengoDe: string, valor: any) {

    if (valor) {

      let tipo_fact = undefined;
      let nombre_prov = undefined;
      let nombre_comercial = undefined;
      let mail = undefined;
      let direccion = undefined;
      let codigoP = undefined;
      let poblacion = undefined;
      let provincia = undefined;
      let pais = undefined;
      let telefono = undefined;
      let TOTAL = undefined;


      if (vengoDe == "FECHA") {

        nombre_prov = this.formulario.get('invoiceName').value;

        if (!nombre_prov) {

          let focusElement = this.renderer.selectRootElement('#invoiceName');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        direccion = this.formulario.get('invoiceDireccion').value;

        if (!direccion) {

          let focusElement = this.renderer.selectRootElement('#invoiceDireccion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "TIPOFACTURA") {

        nombre_prov = this.formulario.get('invoiceName').value;

        if (!nombre_prov) {

          let focusElement = this.renderer.selectRootElement('#invoiceName');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        direccion = this.formulario.get('invoiceDireccion').value;

        if (!direccion) {

          let focusElement = this.renderer.selectRootElement('#invoiceDireccion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "NAMECLIENTE") {



        direccion = this.formulario.get('invoiceDireccion').value;

        if (!direccion) {

          let focusElement = this.renderer.selectRootElement('#invoiceDireccion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "NAMECOMERCIAL") {



        direccion = this.formulario.get('invoiceDireccion').value;

        if (!direccion) {

          let focusElement = this.renderer.selectRootElement('#invoiceDireccion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "MAIL") {

        direccion = this.formulario.get('invoiceDireccion').value;

        if (!direccion) {

          let focusElement = this.renderer.selectRootElement('#invoiceDireccion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "DIRECCION") {

        codigoP = this.formulario.get('invoiceCodigoPostal').value;

        if (!codigoP) {

          let focusElement = this.renderer.selectRootElement('#invoiceCodigoPostal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "CP") {

        poblacion = this.formulario.get('invoicePoblacion').value;

        if (!poblacion) {

          let focusElement = this.renderer.selectRootElement('#invoicePoblacion');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "POBLACION") {

        provincia = this.formulario.get('invoiceProvincia').value;

        if (!provincia) {

          let focusElement = this.renderer.selectRootElement('#invoiceProvincia');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "PROVINCIA") {



        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "PAIS") {

        telefono = this.formulario.get('invoiceTelefono').value;

        if (!telefono) {

          let focusElement = this.renderer.selectRootElement('#invoiceTelefono');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

      if (vengoDe == "TELEFONO") {

        if (typeof (this.formulario.get('invoiceTotal').value) === "string") {

          TOTAL = this.getAmountValue(this.formulario.get('invoiceTotal').value);

        } else {

          TOTAL = this.formulario.get('invoiceTotal').value;
        }

        if (!TOTAL) {

          let focusElement = this.renderer.selectRootElement('#invoiceTotal');
          setTimeout(() => focusElement.focus(), 0);

          return;
        }
      }

    }
  }

  private EsCif(texto: String): boolean {
    //si mide 9 y empieza por una letra es Cif por defecto.

    if (texto.length != 9) {
      return false;
    }

    if (texto.toUpperCase().charCodeAt(0) >= 65 && texto.toUpperCase().charCodeAt(0) <= 90) {
      return true;
    }

    return false;
  }

  private LimpiarCamposDatosClienteProveedor() {
    this.formulario.patchValue({
      invoiceCIF: "",
      invoiceName: "",
      invoiceDireccion: "",
      invoiceNameCom: "",
      invoiceTelefono: "",
      invoiceCodigoPostal: "",
      invoicePoblacion: "",
      invoiceProvincia: "",
      invoicePais: "",
      invoiceMail: ""
    });
  }

  GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  // private LeerPoblacion() {
  //   let codigoPostal: string = this.DevolverValorCeldaString('invoiceCodigoPostal');

  //   if (codigoPostal != '' && this.DevolverValorCeldaString('invoicePoblacion') == '') {


  //     this.invoiceService.ObtenerPoblacion(codigoPostal).subscribe((resp) => {
  //       let poblacionActual = this.DevolverValorCeldaString('invoicePoblacion');
  //       if (resp != '' && poblacionActual == '') {
  //         this.formulario.patchValue({ invoicePoblacion: resp });
  //       }
  //     }, error => {
  //       console.log(error);
  //     });


  //   }
  // }

  ponerProvincia(valorCP: string) {
    var cadenAcomparar = "";

    if (valorCP.length < 5) {

      this.toastr.error("Introduce un código postal de 5 dígitos.")
      this.formulario.patchValue({ invoiceProvincia: '' });
      this.formulario.patchValue({ invoicePoblacion: '' });

    } else {

      this.invoiceService.ObtenerPoblacion(valorCP).subscribe((resp) => {
        // let poblacionActual = this.DevolverValorCeldaString('invoicePoblacion');
        // if (resp != '' && poblacionActual == '') {
        this.formulario.patchValue({ invoicePoblacion: resp });
        // }

        var primeraParte = valorCP.substring(0, 2);

        //SEPARO LOS CARACTERES PARA REVISIÓN DE 0

        var primerCaracter = primeraParte.substring(0, 1);

        var segundoCaracter = primeraParte.substring(1, 2);

        if (primerCaracter == "0") {

          cadenAcomparar = segundoCaracter;

        } else {

          cadenAcomparar = primeraParte;
        }

        let provinciaEspaniola = false;

        for (var i = 0; i < this.paisesAsociadosCP.length; i++) {

          if ((this.paisesAsociadosCP[i].Id).toString() == cadenAcomparar) {

            //si los dos primeros caracteres están en listado con su PROVINCIA...

            this.formulario.patchValue({ invoiceProvincia: this.paisesAsociadosCP[i].Nombre });
            provinciaEspaniola = true;
          }
        }

        if (provinciaEspaniola == true) {

          this.formulario.patchValue({ invoicePais: "ES" });
        }


        if (this.formulario.get('invoiceProvincia').value == '' || this.formulario.get('invoiceProvincia').value == null) {
          this.toastr.error('Este código postal no es correcto.');
          this.formulario.patchValue({ invoiceProvincia: '' });

          return;
        }

        this.saltarCamposLlenos("CP", valorCP);

      }, error => {
        console.log(error);
      });
    }
  }

  visualizarListado() {

    if (this.mostrarListadoDocs) {
      this.mostrarListadoDocs = false;
    } else {
      this.mostrarListadoDocs = true;
    }
  }

  existeFacturaYa(estamosRevisando: boolean, secundario: string, tipoDocumento: number, cif: string, numFactura: string) {

    if (numFactura != '') {

      let cif = this.DevolverValorCeldaString('invoiceCIF');
      let fechaFactura: number = this.GetFechaInteger(this.DevolverValorCeldaString('invoiceDate').trim());

      if (!cif) {
        cif = "vacio";
      }

      if (cif != "vacio" || tipoDocumento == 1) {

        this.invoiceService.existeFacturaIntroducidaDeClienteProveedor(estamosRevisando, secundario, tipoDocumento, cif, numFactura, this.document.id, fechaFactura)
          .subscribe(datosDocMec => {

            if (datosDocMec != null) {

              this.fechaMecanFactura = this.SetFechaString(datosDocMec.fechaRevision);
              this.fechaMecanFacturaPropia = this.SetFechaString(datosDocMec.fecha);
              this.enRevisionModalExisteFactura = false;

              const botonModalExisteFactura = document.getElementById("botonModalExisteFactura") as HTMLElement;
              botonModalExisteFactura.click();

              //Se registra la incidencia de factura duplicada automaticamente...
              this.registrarIncidencia('8');

            } else {

              //Se limpian incidencias de duplicado u otras existentes...
              this.registrarIncidencia('0');
            }
          },
            error => {
              console.log(error);
              this.toastr.error('Error al comprobar si la factura ya existia o ha sido procesada.');
              //this.toastr.error(error);
            });
      }
    }
  }

  fechaChange($event, vieneDe: number) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    if (fechaall.length == 4) {
      this.toastr.error("Fecha incorrecta.");

      if (vieneDe == 1) {
        this.formulario.patchValue({
          invoiceDate: ""
        });

        return;
      }

      if (vieneDe == 2) {

        this.formFiltroGetNext.patchValue({
          filtroFechaSubida: ""
        });

        this.cambiarGetNext($event, false, false, false, true, false);

        return;
      }
    }

    let format = 'dd/mm/yyyy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    //FECHA INTRODUCIDA
    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);
    let anioFecha = "";

    if (fechaall.length == 8) {
      anioFecha = fechaall.substring(6, 8);
    } else {
      anioFecha = fechaall.substring(4, 6);
    }

    //FECHA LIMITE
    let diaLimite = this.fechaHoy.toString().substring(6, 8);
    let mesLimite = this.fechaHoy.toString().substring(4, 6);
    let anioLimite = this.fechaHoy.toString().substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        console.log("Revisando que la fecha no sea superior al dia actual...");
        console.warn("Dia introducido: " + diasMes);
        console.warn("Mes introducido: " + mesFecha);
        console.warn("Anio introducido: " + anioFecha);

        if (parseInt(anioFecha) > parseInt(anioLimite)) {

          this.toastr.error('Fecha incorrecta. No puede ser superior al dia actual.');
          resultado = "";

          if (vieneDe == 1) {
            this.formulario.patchValue({
              invoiceDate: resultado
            });

            if (resultado) {

              this.saltarCamposLlenos("FECHA", this.formulario.get('invoiceDate').value);
            }

            return;
          }

          if (vieneDe == 2) {

            this.formFiltroGetNext.patchValue({
              filtroFechaSubida: resultado
            });

            this.cambiarGetNext($event, false, false, false, true, false);

            return;
          }

        } else if (parseInt(anioFecha) == parseInt(anioLimite) && parseInt(mesFecha) > parseInt(mesLimite)) {

          this.toastr.error('Fecha incorrecta. No puede ser superior al dia actual.');
          resultado = "";

          if (vieneDe == 1) {
            this.formulario.patchValue({
              invoiceDate: resultado
            });

            if (resultado) {

              this.saltarCamposLlenos("FECHA", this.formulario.get('invoiceDate').value);
            }

            return;
          }

          if (vieneDe == 2) {

            this.formFiltroGetNext.patchValue({
              filtroFechaSubida: resultado
            });

            this.cambiarGetNext($event, false, false, false, true, false);

            return;
          }

        } else if (parseInt(anioFecha) == parseInt(anioLimite) && parseInt(mesFecha) == parseInt(mesLimite) && parseInt(diasMes) > parseInt(diaLimite)) {

          this.toastr.error('Fecha incorrecta. No puede ser superior al dia actual.');
          resultado = "";

          if (vieneDe == 1) {
            this.formulario.patchValue({
              invoiceDate: resultado
            });

            if (resultado) {

              this.saltarCamposLlenos("FECHA", this.formulario.get('invoiceDate').value);
            }

            return;
          }

          if (vieneDe == 2) {

            this.formFiltroGetNext.patchValue({
              filtroFechaSubida: resultado
            });

            return;
          }
        }

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }
      }
    }

    if (vieneDe == 1) {
      this.formulario.patchValue({
        invoiceDate: resultado
      });

      if (resultado) {

        this.saltarCamposLlenos("FECHA", this.formulario.get('invoiceDate').value);
      }
    }

    if (vieneDe == 2) {

      this.formFiltroGetNext.patchValue({
        filtroFechaSubida: resultado
      });

      this.cambiarGetNext($event, false, false, false, true, false);
    }
  }

  registrarIncidencia(opcion: string) {

    let dato: any = {};

    this.tiposDeIncidencias.forEach(element => {
      if (element.id == parseInt(opcion)) {
        dato = element;
      }
    });

    if (!dato) {
      return;
    }

    this.IDincidenciaPorModal = dato.idInterno;

    this.clickCheckIncidencia();

    if (dato.id == 10) {
      this.borrarDatosEnFacturaIncompleta();
    }

  }

  borrarDatosEnFacturaIncompleta() {
    //Si la incidencia marcada es 'Factura incompleta' borrar numero de factura e importes...

    this.formulario.patchValue({

      invoiceNumber: '',
      invoiceTotal: '',
      invoiceSuplidos: '',
      imponibles: {
        invoiceBase1: '',
        invoiceBase2: '',
        invoiceBase3: '',
        invoiceBase4: '',
        invoiceBase5: '',
        invoiceBase6: '',
        invoicePorIva1: '',
        invoicePorIva2: '',
        invoicePorIva3: '',
        invoicePorIva4: '',
        invoicePorIva5: '',
        invoicePorIva6: '',
        invoiceCuotaIva1: '',
        invoiceCuotaIva2: '',
        invoiceCuotaIva3: '',
        invoiceCuotaIva4: '',
        invoiceCuotaIva5: '',
        invoiceCuotaIva6: '',
        invoicePorRecargo1: '',
        invoicePorRecargo2: '',
        invoicePorRecargo3: '',
        invoicePorRecargo4: '',
        invoicePorRecargo5: '',
        invoicePorRecargo6: '',
        invoiceCuotaRecargo1: '',
        invoiceCuotaRecargo2: '',
        invoiceCuotaRecargo3: '',
        invoiceCuotaRecargo4: '',
        invoiceCuotaRecargo5: '',
        invoiceCuotaRecargo6: '',
      },
      retenciones: {
        invoiceBaseRetencion: '',
        invoicePorRetencion: '',
        invoiceCuotaRetencion: '',
        invoiceTipoRetencion: ''
      }
    });

  }

  separarPaginas() {

    console.warn("Separando documento actual y almacenandolo en ruta por defecto Azure...");
    this.separando = true;
    this.preguntaSepararRealizada = true;

    this.invoiceService.SepararDocumento(this.document.id).subscribe(resultado => {

      if (resultado) {
        this.toastr.info("Se ha separado el documento correctamente.");
      } else {
        this.toastr.error("Error al separar el documento seleccionado manualmente.");
      }

    }, error => {
      this.toastr.error("Error al separar el documento seleccionado manualmente");
      console.log(error);
    });

    setTimeout(() => {

      this.preguntaSepararRealizada = false;
      const botonCerrarModal = document.getElementById("cerrarAvisoSEP") as HTMLElement;
      botonCerrarModal.click();
      this.filtroFecha = this.formFiltroGetNext.get('filtroFechaSubida').value;
      this.getNextInvoice(this.valorEstadoNEXT, this.valorSecPrinNEXT, this.valorTipoNEXT, this.filtroCIF, this.filtroFecha, this.filtroUsuSUPER);
    }, 8000);

    this.separando = false;
  }

  limpiarListadoEmpresa() {

    this.listadoEmpresas = [];

    this.invoiceFormBUSCADOREMP.patchValue({
      invoiceBuscadorEMP: ''
    });

  }

  buscarEmpresaNameNif() {

    let valorEMP: string = this.invoiceFormBUSCADOREMP.get('invoiceBuscadorEMP').value;
    this.listadoEmpresas = [];


    this.invoiceService.obtenerListadoEmpresasConNifName(valorEMP).subscribe(empresas => {

      for (var i = 0; i < empresas.length; i++) {

        this.listadoEmpresas.push(empresas[i]);

      }

      console.warn(this.listadoEmpresas);



    }, error => {
      console.log(error);
    });

    this.ListaEmpresasGenerada = true;
  }

  cargarDatosEmpresaSelecc(idEmpresa: string) {

    let focusElement = this.renderer.selectRootElement('#invoiceNumber');
    setTimeout(() => focusElement.focus(), 0);

    this.nifChange(idEmpresa);

    this.formulario.patchValue({
      invoiceCIF: idEmpresa.toUpperCase()
    });

    this._valorNIF = idEmpresa.toUpperCase();

    const botonModalCERRAR = document.getElementById("cerrarMODALBUSQ") as HTMLElement;
    botonModalCERRAR.click();

    focusElement = this.renderer.selectRootElement('#invoiceNumber');
    setTimeout(() => focusElement.focus(), 0);
  }

  nifChange($event) {

    let cif: string = "";

    if (typeof ($event) === "string") {

      cif = $event;
    } else {

      cif = $event.target.value;
    }

    this._valorNIF = cif;

    if (cif) {
      this.loading = true;
      cif = cif.replace(/[^a-zA-Z0-9]/g, '');

      if (cif.length < 9) {

        let primerCaracter: string = cif.charAt(0);
        let expresionRegular = new RegExp(/^\d/);
        let resultadoComparacion = expresionRegular.test(primerCaracter);

        if (resultadoComparacion) {

          // si comienza por un numero y es menor de 9 la longitud se rellena con '0' al principio de la cadena.

          let tamanioNif: number = cif.length;
          const cerosRelleno = '0';

          do {

            cif = cerosRelleno + cif;
            tamanioNif++;

          } while (tamanioNif < 9);

          this.formulario.patchValue({
            invoiceCIF: cif
          });
        } else {
          this.loading = false;
          this.toastr.error('El nif del proveedor o cliente puede no ser correcto.');
          return;
        }
      }

      //SI ES DE DOCUMENTOS EMITIDOS
      if (this.document.tipoDocumento == 1) {

        var valor_nif: string = this.formulario.get('invoiceCIF').value;

        if (valor_nif == null) {
          valor_nif = cif;
        }

        if (this.nifCifClienteProveedor.toUpperCase() == cif.toUpperCase()) {

          this.toastr.error("El NIF/CIF no puede ser el mismo que el de la empresa del usuario secundario.");
          this.formulario.patchValue({ invoiceCIF: '' });

          this.formulario.patchValue({ invoiceName: '' });
          this.formulario.patchValue({ invoiceNameCom: '' });
          this.formulario.patchValue({ invoiceDireccion: '' });
          this.formulario.patchValue({ invoiceCodigoPostal: '' });
          this.formulario.patchValue({ invoicePoblacion: '' });
          this.formulario.patchValue({ invoiceProvincia: '' });
          this.formulario.patchValue({ invoicePais: '' });
          this.formulario.patchValue({ invoiceTelefono: '' });
          this.formulario.patchValue({ invoiceMail: '' });

          this.bloqueadoRojo = false;
          this.loading = false;
          return;
        }

        this.invoiceService.getCompany(cif).subscribe(company => {

          if (company == null) {
            this.formulario.patchValue({
              invoiceName: "",
              invoiceDireccion: "",
              invoiceNameCom: "",
              invoiceTelefono: "",
              invoiceCodigoPostal: "",
              invoicePoblacion: "",
              invoiceProvincia: "",
              invoicePais: "",
              invoiceMail: "",
              invoiceObsINTER: ""
            });

            this.toastr.error("C.I.F./N.I.F. no encontrado.");
            this.loading = false;

            let focusElement = this.renderer.selectRootElement('#invoiceNumber');
            setTimeout(() => focusElement.focus(), 0);

          } else {

            this.formulario.patchValue({
              invoiceName: company.nombre,
              invoiceDireccion: company.domicilio,
              invoiceNameCom: company.nComercial,
              invoiceTelefono: company.telefono,
              invoiceCodigoPostal: company.codigoPostal,
              invoicePoblacion: company.poblacion,
              invoiceProvincia: company.provincia,
              invoicePais: company.pais,
              invoiceMail: company.email,
              invoiceObsINTER: company.observaciones
            });

            for (var i = 0; i < this.paisesAsociadosCP.length; i++) {

              if (company.provincia) {

                if (company.provincia == this.paisesAsociadosCP[i].Nombre) { //si ha traido una provincia que es española..

                  //seleccionara el pais ESPAÑA.

                  this.formulario.patchValue({
                    invoicePais: 'ES'
                  });

                }
              }
            }

            // si nos viene la propiedad EstaEnNuestraBD del objeto compania...

            if (company.estaEnNuestraBD) {

              if (this.revisionVerde == false) {

                this.bloqueadoRojo = false;
              }

            } else if (!company.estaEnNuestraBD) {

              if (this.revisionVerde == false) {

                this.bloqueadoRojo = true;
              }
            }

            const focusElement = this.renderer.selectRootElement('#invoiceNumber');
            setTimeout(() => focusElement.focus(), 0);

            this.loading = false;
          }

        }, error => {
          this.loading = false;
          this.toastr.error(error);

          this.formulario.patchValue({ invoiceName: '' });
          this.formulario.patchValue({ invoiceNameCom: '' });
          this.formulario.patchValue({ invoiceDireccion: '' });
          this.formulario.patchValue({ invoiceCodigoPostal: '' });
          this.formulario.patchValue({ invoicePoblacion: '' });
          this.formulario.patchValue({ invoiceProvincia: '' });
          this.formulario.patchValue({ invoicePais: '' });
          this.formulario.patchValue({ invoiceTelefono: '' });
          this.formulario.patchValue({ invoiceMail: '' });
          this.formulario.patchValue({ invoiceObsINTER: '' });

          this.bloqueadoRojo = false;
        });

        this._valorNIF = this.formulario.get('invoiceCIF').value;

      }

      //SI ES DE DOCUMENTOS RECIBIDOS
      if (this.document.tipoDocumento == 2) {

        let valor_nif: string = this.formulario.get('invoiceCIF').value;

        if (valor_nif == null) {
          valor_nif = cif;
        }

        if (this.nifCifClienteProveedor == valor_nif.toUpperCase()) {

          this.toastr.error("El NIF/CIF no puede ser el mismo que el del usuario secundario.");
          this.formulario.patchValue({ invoiceCIF: '' });
          this.formulario.patchValue({ invoiceName: '' });
          this.formulario.patchValue({ invoiceNameCom: '' });
          this.formulario.patchValue({ invoiceDireccion: '' });
          this.formulario.patchValue({ invoiceCodigoPostal: '' });
          this.formulario.patchValue({ invoicePoblacion: '' });
          this.formulario.patchValue({ invoiceProvincia: '' });
          this.formulario.patchValue({ invoicePais: '' });
          this.formulario.patchValue({ invoiceTelefono: '' });
          this.formulario.patchValue({ invoiceMail: '' });
          this.formulario.patchValue({ invoiceObsINTER: '' });

          this.bloqueadoRojo = false;
          this.loading = false;

          return;
        }

        this.invoiceService.getCompany(cif).subscribe(company => {

          if (company == null) {
            this.formulario.patchValue({
              invoiceName: "",
              invoiceDireccion: "",
              invoiceNameCom: "",
              invoiceTelefono: "",
              invoiceCodigoPostal: "",
              invoicePoblacion: "",
              invoiceProvincia: "",
              invoicePais: "",
              invoiceMail: "",
              invoiceObsINTER: ""
            });

            this.toastr.error("C.I.F./N.I.F. no encontrado.");
            this.loading = false;

            let focusElement = this.renderer.selectRootElement('#invoiceNumber');
            setTimeout(() => focusElement.focus(), 0);

          } else {

            this.formulario.patchValue({
              invoiceName: company.nombre,
              invoiceDireccion: company.domicilio,
              invoiceNameCom: company.nComercial,
              invoiceTelefono: company.telefono,
              invoiceCodigoPostal: company.codigoPostal,
              invoicePoblacion: company.poblacion,
              invoiceProvincia: company.provincia,
              invoicePais: company.pais,
              invoiceMail: company.email,
              invoiceObsINTER: company.observaciones
            });

            for (var i = 0; i < this.paisesAsociadosCP.length; i++) {

              if (company.provincia) {

                if (company.provincia == this.paisesAsociadosCP[i].Nombre) { //si ha traido una provincia que es española..

                  //seleccionara el pais ESPAÑA.

                  this.formulario.patchValue({
                    invoicePais: 'ES'
                  });

                }
              }
            }

            // si nos viene la propiedad EstaEnNuestraBD del objeto compania...

            if (company.estaEnNuestraBD) {

              if (this.revisionVerde == false) {

                this.bloqueadoRojo = false;
              }

            } else if (!company.estaEnNuestraBD) {

              if (this.revisionVerde == false) {

                this.bloqueadoRojo = true;
              }
            }

            const focusElement = this.renderer.selectRootElement('#invoiceNumber');
            setTimeout(() => focusElement.focus(), 0);

            this.loading = false;
          }


        }, error => {
          this.loading = false;
          this.toastr.error(error);

          this.formulario.patchValue({ invoiceName: '' });
          this.formulario.patchValue({ invoiceNameCom: '' });
          this.formulario.patchValue({ invoiceDireccion: '' });
          this.formulario.patchValue({ invoiceCodigoPostal: '' });
          this.formulario.patchValue({ invoicePoblacion: '' });
          this.formulario.patchValue({ invoiceProvincia: '' });
          this.formulario.patchValue({ invoicePais: '' });
          this.formulario.patchValue({ invoiceTelefono: '' });
          this.formulario.patchValue({ invoiceMail: '' });
          this.formulario.patchValue({ invoiceObsINTER: '' });

          this.bloqueadoRojo = false;
        });

        this._valorNIF = this.formulario.get('invoiceCIF').value;
      }


      ////////////////////////////////////////////////////////////////////////
      //Petición de datos a devolver sobre las caracteristicas del proveedor(CIF introducido) ya usadas previamente...

      if (this.esEmpresaDeCanarias == false) {

        this.invoiceService.getDatosProveedor(cif).subscribe(SupplierFeatures => {

          if (SupplierFeatures == null) {

            this.toastr.error('No se encontraron datos de facturas anteriores con este proveedor.');
            return;

          } else {

            this.toastr.info('Autocompletando formulario con datos de la última factura de este proveedor...');

            if (SupplierFeatures.tipoRetencion > 0) {

              if (SupplierFeatures.tipoFactura == 0) {

                SupplierFeatures.tipoFactura = 1;
              }

              this.formulario.patchValue({

                invoiceTipoFactura: (SupplierFeatures.tipoFactura == 8 || SupplierFeatures.tipoFactura == 9) ? 1 : SupplierFeatures.tipoFactura,
                imponibles: {
                  invoicePorIva1: this.redondearExp(SupplierFeatures.porIva1, 2),
                  invoicePorIva2: this.redondearExp(SupplierFeatures.porIva2, 2),
                  invoicePorIva3: this.redondearExp(SupplierFeatures.porIva3, 2),
                  invoicePorIva4: this.redondearExp(SupplierFeatures.porIva4, 2),
                  invoicePorIva5: this.redondearExp(SupplierFeatures.porIva5, 2)
                  // invoicePorIva6: this.redondearExp(SupplierFeatures.porIva6, 2),
                  // invoicePorIva7: this.redondearExp(SupplierFeatures.porIva7, 2),
                  // invoicePorIva8: this.redondearExp(SupplierFeatures.porIva8, 2)
                },
                retenciones: {
                  invoicePorRetencion: SupplierFeatures.porRetencion.toString(),
                  invoiceTipoRetencion: SupplierFeatures.tipoRetencion
                }
              });

            } else {

              if (SupplierFeatures.tipoFactura == 0) {

                SupplierFeatures.tipoFactura = 1;
              }

              this.formulario.patchValue({
                invoiceTipoFactura: (SupplierFeatures.tipoFactura == 8 || SupplierFeatures.tipoFactura == 9) ? 1 : SupplierFeatures.tipoFactura,
                imponibles: {
                  invoicePorIva1: this.redondearExp(SupplierFeatures.porIva1, 2),
                  invoicePorIva2: this.redondearExp(SupplierFeatures.porIva2, 2),
                  invoicePorIva3: this.redondearExp(SupplierFeatures.porIva3, 2),
                  invoicePorIva4: this.redondearExp(SupplierFeatures.porIva4, 2),
                  invoicePorIva5: this.redondearExp(SupplierFeatures.porIva5, 2)
                  // invoicePorIva6: this.redondearExp(SupplierFeatures.porIva6, 2),
                  // invoicePorIva7: this.redondearExp(SupplierFeatures.porIva7, 2),
                  // invoicePorIva8: this.redondearExp(SupplierFeatures.porIva8, 2)
                }
              });

            }
          }

          if (this.formulario.get('invoiceNumber').value) {

            this.existeFacturaYa(this.revisionVerde, this.document.secundario, this.document.tipoDocumento, cif, this.formulario.get('invoiceNumber').value)
          }

        }, error => {
          console.log(error);
        });

      } else {

        if (this.formulario.get('invoiceNumber').value) {

          this.existeFacturaYa(this.revisionVerde, this.document.secundario, this.document.tipoDocumento, cif, this.formulario.get('invoiceNumber').value)
        }
      }

    } else {

      this.formulario.patchValue({ invoiceName: '' });
      this.formulario.patchValue({ invoiceNameCom: '' });
      this.formulario.patchValue({ invoiceDireccion: '' });
      this.formulario.patchValue({ invoiceCodigoPostal: '' });
      this.formulario.patchValue({ invoicePoblacion: '' });
      this.formulario.patchValue({ invoiceProvincia: '' });
      this.formulario.patchValue({ invoicePais: '' });
      this.formulario.patchValue({ invoiceTelefono: '' });
      this.formulario.patchValue({ invoiceMail: '' });
      this.formulario.patchValue({ invoiceObsINTER: '' });

      this.numeroDocumentosConNIFactualConDatos = -1;
      this.numeroDocumentosConNIFactualConDatosPendientes = -1;
      this.bloqueadoRojo = false;
      //this.revisionVerde = false;
    }

    let focusElement = this.renderer.selectRootElement('#invoiceNumber');
    setTimeout(() => focusElement.focus(), 0);



    //Que haga la comporbacion solo si es RECIBIDA. Con EMITIDAS no cambia el NIF.
    if (this.document.tipoDocumento == 2) {

      //ChequeoPlantilla...
      var nif: string = this.formulario.get('invoiceCIF').value;

      if (nif) {

        this.ObtenerNumeroFacturasNIF(nif, 2);
        this.ObtenerNumeroFacturasPorNIFPendientes(nif, 2, this.document.secundario);
      }
    }
  }

  moverFocoAlCerraModalesIniciales() {

    let focusElement = this.renderer.selectRootElement('#invoiceCIF');
    setTimeout(() => focusElement.focus(), 0);

  }

  filtrarNIF($event) {

    if (this.isNotNumberAndText($event) == false) {

      $event.preventDefault();
    }
  }

  cargarUltimasEmpresasBuscador(usuarioSDM: string) {
    this.listadoEmpresas = [];

    this.invoiceService.cargarUltimasEmpresasBuscador(usuarioSDM).subscribe(empresas => {

      for (var i = 0; i < empresas.length; i++) {

        this.listadoEmpresas.push(empresas[i]);

      }
    }, error => {
      console.log(error);
    });

    this.ListaEmpresasGenerada = true;
  }

  cargarUltimoNif(usuarioSdm: string) {

    this.invoiceService.obtenerUltimoNifDeUserActual(usuarioSdm).subscribe(nif => {

      if (nif == null) {

        this.formulario.patchValue({
          invoiceCIF: ''
        });

        this.toastr.error("No se ha podido encontrar su último NIF introducido...");

        this._valorNIF = '';

        return;
      }

      this.formulario.patchValue({
        invoiceCIF: nif.toUpperCase()
      });

      this._valorNIF = nif.toUpperCase();

      this.toastr.success("Último NIF introducido cargado con éxito...");

      this.nifChange(nif);

    }, error => {
      console.log(error);
    });

  }

  totalChange($event) {

    if (!$event) {

      this.formulario.patchValue({
        imponibles: {
          invoiceBase1: undefined,
          invoiceBase2: undefined,
          invoiceBase3: undefined,
          invoiceBase4: undefined,
          invoiceBase5: undefined,
          invoiceBase6: undefined,
          invoicePorIva1: undefined,
          invoicePorIva2: undefined,
          invoicePorIva3: undefined,
          invoicePorIva4: undefined,
          invoicePorIva5: undefined,
          invoicePorIva6: undefined,
          invoiceCuotaIva1: undefined,
          invoiceCuotaIva2: undefined,
          invoiceCuotaIva3: undefined,
          invoiceCuotaIva4: undefined,
          invoiceCuotaIva5: undefined,
          invoiceCuotaIva6: undefined,
          invoicePorRecargo1: undefined,
          invoicePorRecargo2: undefined,
          invoicePorRecargo3: undefined,
          invoicePorRecargo4: undefined,
          invoicePorRecargo5: undefined,
          invoicePorRecargo6: undefined,
          invoiceCuotaRecargo1: undefined,
          invoiceCuotaRecargo2: undefined,
          invoiceCuotaRecargo3: undefined,
          invoiceCuotaRecargo4: undefined,
          invoiceCuotaRecargo5: undefined,
          invoiceCuotaRecargo6: undefined
        },
        retenciones: {
          invoiceBaseRetencion: undefined,
          invoicePorRetencion: undefined,
          invoiceCuotaRetencion: undefined,
          invoiceTipoRetencion: undefined,
        }
      });

      return;
    }

    let totalFactura = undefined;
    let suplidos = undefined;



    if (typeof $event === "string") {

      if ($event.match(/\,/)) {
        $event = $event.replace(',', '.');
      }

      this._valorTotalFactura = $event;
      totalFactura = parseFloat($event);

      suplidos = this.getAmountValue(this.formulario.get('invoiceSuplidos').value);

      if (suplidos) {
        totalFactura = totalFactura - suplidos;
      }

    } else {

      if (!$event.target.value) {
        this.inicializarBasesCuotas();
        return;
      }

      if ($event.target.value.toString().match(/\,/)) {
        $event.target.value = $event.target.value.replace(',', '.');
      }

      this._valorTotalFactura = $event;
      suplidos = undefined;

      if (typeof (this.formulario.get('invoiceSuplidos').value) === "string") {
        suplidos = this.getAmountValue(this.formulario.get('invoiceSuplidos').value);
      } else {
        suplidos = this.formulario.get('invoiceSuplidos').value;
      }

      totalFactura = parseFloat($event.target.value);

      if (suplidos) {
        totalFactura = Number(this.redondearExp(totalFactura - suplidos, 2));
      }

      if (this.DevolverValorCeldaBoolean('invoiceEsTicket') == true) {

        //Inicializar todas las casillas de bases y cuotas.
        this.inicializarBasesCuotas();
        let totalFacturaNormalizado = this.DevolverValorCeldaNumber('invoiceTotal', "");

        this.formulario.patchValue({
          imponibles: {
            invoiceBase1: (totalFacturaNormalizado == 0) ? undefined : totalFacturaNormalizado
          }
        });

        return;
      }
    }

    let base2 = null;
    let base3 = null;
    let base4 = null;
    let base5 = null;
    let base6 = null;
    let por2 = null;
    let por3 = null;
    let por4 = null;
    let por5 = null;
    let por6 = null;
    let cuota2 = null;
    let cuota3 = null;
    let cuota4 = null;
    let cuota5 = null;
    let cuota6 = null;
    let porRetencion = null;

    //en caso de que se esté calculando desde un documento de estado YA PROCESADO (update)

    if (typeof (this.formulario.get('imponibles').get('invoiceBase2').value) === "string") {
      base2 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceBase2').value);
    } else {
      base2 = this.formulario.get('imponibles').get('invoiceBase2').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceBase3').value) === "string") {
      base3 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceBase3').value);
    } else {
      base3 = this.formulario.get('imponibles').get('invoiceBase3').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceBase4').value) === "string") {
      base4 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceBase4').value);
    } else {
      base4 = this.formulario.get('imponibles').get('invoiceBase4').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceBase5').value) === "string") {
      base5 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceBase5').value);
    } else {
      base5 = this.formulario.get('imponibles').get('invoiceBase5').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceBase6').value) === "string") {
      base6 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceBase6').value);
    } else {
      base6 = this.formulario.get('imponibles').get('invoiceBase6').value;
    }
    //////////////////////////////////
    if (typeof (this.formulario.get('imponibles').get('invoicePorIva2').value) === "string") {
      por2 = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva2').value);
    } else {
      por2 = this.formulario.get('imponibles').get('invoicePorIva2').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoicePorIva3').value) === "string") {
      por3 = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva3').value);
    } else {
      por3 = this.formulario.get('imponibles').get('invoicePorIva3').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoicePorIva4').value) === "string") {
      por4 = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva4').value);
    } else {
      por4 = this.formulario.get('imponibles').get('invoicePorIva4').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoicePorIva5').value) === "string") {
      por5 = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva5').value);
    } else {
      por5 = this.formulario.get('imponibles').get('invoicePorIva5').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoicePorIva6').value) === "string") {
      por6 = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva6').value);
    } else {
      por6 = this.formulario.get('imponibles').get('invoicePorIva6').value;
    }
    /////////////////////////////////////
    if (typeof (this.formulario.get('imponibles').get('invoiceCuotaIva2').value) === "string") {
      cuota2 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceCuotaIva2').value);
    } else {
      cuota2 = this.formulario.get('imponibles').get('invoiceCuotaIva2').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceCuotaIva3').value) === "string") {
      cuota3 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceCuotaIva3').value);
    } else {
      cuota3 = this.formulario.get('imponibles').get('invoiceCuotaIva3').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceCuotaIva4').value) === "string") {
      cuota4 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceCuotaIva4').value);
    } else {
      cuota4 = this.formulario.get('imponibles').get('invoiceCuotaIva4').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceCuotaIva5').value) === "string") {
      cuota5 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceCuotaIva5').value);
    } else {
      cuota5 = this.formulario.get('imponibles').get('invoiceCuotaIva5').value;
    }
    if (typeof (this.formulario.get('imponibles').get('invoiceCuotaIva6').value) === "string") {
      cuota6 = this.getAmountValue(this.formulario.get('imponibles').get('invoiceCuotaIva6').value);
    } else {
      cuota6 = this.formulario.get('imponibles').get('invoiceCuotaIva6').value;
    }
    ////////////////////////////////////////
    if (typeof (this.formulario.get('retenciones').get('invoicePorRetencion').value) === "string") {
      porRetencion = this.getAmountValue(this.formulario.get('retenciones').get('invoicePorRetencion').value);
    } else {
      porRetencion = this.formulario.get('retenciones').get('invoicePorRetencion').value;
    }

    const tipoDeFacturaSelecc = parseInt(this.formulario.get('invoiceTipoFactura').value);
    let tipoRetencion = this.formulario.get('retenciones').get('invoiceTipoRetencion').value;

    //RECIBIDAS
    if (this.document.tipoDocumento == 2) {

      //Si la factura es de alguno de estos tipos, solo se tendrá en cuenta las bases imponibles, de manera que la suma de estas es IGUAL AL TOTAL
      if (tipoDeFacturaSelecc == 2 || tipoDeFacturaSelecc == 5 || tipoDeFacturaSelecc == 6 || tipoDeFacturaSelecc == 8 || tipoDeFacturaSelecc == 9) {

        let porIva = 21;

        // if (typeof (this.formulario.get('imponibles').get('invoicePorIva1').value) === "string") {
        //   porIva = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva1').value);
        // } else {
        //   porIva = this.formulario.get('imponibles').get('invoicePorIva1').value;
        // }

        // // if (!porIva) {
        // // if (this.esEmpresaDeCanarias == true) {
        // //   porIva = 0;
        // // } else {
        // porIva = 21;
        // // }
        // // }

        const base = Number(this.redondearExp(totalFactura, 2));
        let cuota = base * (porIva / 100);
        cuota = Number(this.redondearExp(cuota, 2));

        this.formulario.patchValue({
          imponibles: {
            invoiceBase1: this.redondearExp(base, 2),
            invoicePorIva1: this.redondearExp(porIva, 2),
            invoiceCuotaIva1: this.redondearExp(cuota, 2)
          }
        });

        ///////////////////////////////////////
        //Se limpian las bases a causa de nuevo total

        base2 = undefined;
        por2 = undefined;
        cuota2 = undefined;
        base3 = undefined;
        por3 = undefined;
        cuota3 = undefined;
        base4 = undefined;
        por4 = undefined;
        cuota4 = undefined;
        base5 = undefined;
        por5 = undefined;
        cuota5 = undefined;
        base6 = undefined;
        por6 = undefined;
        cuota6 = undefined;

        this.formulario.patchValue({
          imponibles: {
            invoicePorIva2: por2,
            invoiceCuotaIva2: cuota2,
            invoiceBase2: base2,
            invoicePorIva3: por3,
            invoiceCuotaIva3: cuota3,
            invoiceBase3: base3,
            invoicePorIva4: por4,
            invoiceCuotaIva4: cuota4,
            invoiceBase4: base4,
            invoicePorIva5: por5,
            invoiceCuotaIva5: cuota5,
            invoiceBase5: base5,
            invoicePorIva6: por6,
            invoiceCuotaIva6: cuota6,
            invoiceBase6: base6
          }
        });

      } else {

        if (porRetencion && tipoRetencion) {

          let porIva = undefined;

          if (this.isNumber(this.formulario.get('imponibles').get('invoicePorIva1').value)) {

            if (suplidos) {
              porIva = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva1').value);
            } else {
              porIva = this.formulario.get('imponibles').get('invoicePorIva1').value;
            }

            if (!suplidos && typeof porIva === 'string') {
              porIva = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva1').value);
            }

          } else {
            porIva = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva1').value);
          }

          if (!porIva) {

            if (this.esEmpresaDeCanarias == true) {
              porIva = 0;
            } else {
              porIva = 21;
            }
          }


          let base = Number(this.redondearExp(totalFactura, 2)) / (1 + ((porIva / 100) - (porRetencion / 100)));
          base = Number(this.redondearExp(base, 2));
          let cuota = base * (porIva / 100);
          cuota = Number(this.redondearExp(cuota, 2));

          this.formulario.patchValue({
            imponibles: {
              invoiceBase1: this.redondearExp(base, 2),
              invoicePorIva1: this.redondearExp(porIva, 2),
              invoiceCuotaIva1: this.redondearExp(cuota, 2)
            },
            retenciones: {
              invoiceBaseRetencion: this.redondearExp(base, 2)
            }
          });

          this.retencionChange();

          ///////////////////////////////////////
          //Se limpian las bases a causa de nuevo total

          base2 = undefined;
          por2 = undefined;
          cuota2 = undefined;
          base3 = undefined;
          por3 = undefined;
          cuota3 = undefined;
          base4 = undefined;
          por4 = undefined;
          cuota4 = undefined;
          base5 = undefined;
          por5 = undefined;
          cuota5 = undefined;
          base6 = undefined;
          por6 = undefined;
          cuota6 = undefined;

          this.formulario.patchValue({
            imponibles: {
              invoicePorIva2: por2,
              invoiceCuotaIva2: cuota2,
              invoiceBase2: base2,
              invoicePorIva3: por3,
              invoiceCuotaIva3: cuota3,
              invoiceBase3: base3,
              invoicePorIva4: por4,
              invoiceCuotaIva4: cuota4,
              invoiceBase4: base4,
              invoicePorIva5: por5,
              invoiceCuotaIva5: cuota5,
              invoiceBase5: base5,
              invoicePorIva6: por6,
              invoiceCuotaIva6: cuota6,
              invoiceBase6: base6
            }
          });

        } else {

          if (tipoDeFacturaSelecc == 3 || tipoDeFacturaSelecc == 7) { //Si son importanciones no se generan IVAs no cuotas...

            let base = Number(this.redondearExp(totalFactura, 2));

            this.formulario.patchValue({
              imponibles: {
                invoiceBase1: this.redondearExp(base, 2),
                invoicePorIva1: 0,
                invoiceCuotaIva1: 0
              }
            });

          } else {

            let porIva = null;

            if (this.aplicarColorROJO == true) {
              porIva = this.formulario.get('imponibles').get('invoicePorIva1').value;
            } else {

              var val: string = (this.formulario.get('imponibles').get('invoicePorIva1').value) ? (this.formulario.get('imponibles').get('invoicePorIva1').value).toString() : "";
              porIva = this.getAmountValue(val);
            }

            if (!porIva) {
              if (this.esEmpresaDeCanarias == true) {
                porIva = 0;
              } else {
                porIva = 21;
              }
            } else {
              porIva = parseFloat(porIva);
            }

            let base = Number(this.redondearExp(totalFactura, 2)) / (1 + (porIva / 100));
            base = Number(this.redondearExp(base, 2));
            let cuota = totalFactura - base;
            cuota = Number(this.redondearExp(cuota, 2));

            this.formulario.patchValue({
              imponibles: {
                invoiceBase1: this.redondearExp(base, 2),
                invoicePorIva1: this.redondearExp(porIva, 2),
                invoiceCuotaIva1: this.redondearExp(cuota, 2)
              }
            });
          }

          ///////////////////////////////////////
          //Se limpian las bases a causa de nuevo total

          base2 = undefined;
          por2 = undefined;
          cuota2 = undefined;
          base3 = undefined;
          por3 = undefined;
          cuota3 = undefined;
          base4 = undefined;
          por4 = undefined;
          cuota4 = undefined;
          base5 = undefined;
          por5 = undefined;
          cuota5 = undefined;
          base6 = undefined;
          por6 = undefined;
          cuota6 = undefined;

          this.formulario.patchValue({
            imponibles: {
              invoicePorIva2: por2,
              invoiceCuotaIva2: cuota2,
              invoiceBase2: base2,
              invoicePorIva3: por3,
              invoiceCuotaIva3: cuota3,
              invoiceBase3: base3,
              invoicePorIva4: por4,
              invoiceCuotaIva4: cuota4,
              invoiceBase4: base4,
              invoicePorIva5: por5,
              invoiceCuotaIva5: cuota5,
              invoiceBase5: base5,
              invoicePorIva6: por6,
              invoiceCuotaIva6: cuota6,
              invoiceBase6: base6
            }
          });
        }
      }
    }

    //EMITIDAS
    if (this.document.tipoDocumento == 1) {

      //Si la factura es de alguno de estos tipos, solo se tendrá en cuenta las bases imponibles, de manera que la suma de estas es IGUAL AL TOTAL
      if (tipoDeFacturaSelecc == 2 || tipoDeFacturaSelecc == 3 || tipoDeFacturaSelecc == 5 || tipoDeFacturaSelecc == 6 || tipoDeFacturaSelecc == 7) {

        const base = totalFactura;

        this.formulario.patchValue({
          imponibles: {
            invoiceBase1: this.redondearExp(base, 2),
            invoicePorIva1: 0,
            invoiceCuotaIva1: 0,
          }
        });

        ///////////////////////////////////////
        //Se limpian las bases a causa de nuevo total

        base2 = undefined;
        por2 = undefined;
        cuota2 = undefined;
        base3 = undefined;
        por3 = undefined;
        cuota3 = undefined;
        base4 = undefined;
        por4 = undefined;
        cuota4 = undefined;
        base5 = undefined;
        por5 = undefined;
        cuota5 = undefined;
        base6 = undefined;
        por6 = undefined;
        cuota6 = undefined;

        this.formulario.patchValue({
          imponibles: {
            invoicePorIva2: por2,
            invoiceCuotaIva2: cuota2,
            invoiceBase2: base2,
            invoicePorIva3: por3,
            invoiceCuotaIva3: cuota3,
            invoiceBase3: base3,
            invoicePorIva4: por4,
            invoiceCuotaIva4: cuota4,
            invoiceBase4: base4,
            invoicePorIva5: por5,
            invoiceCuotaIva5: cuota5,
            invoiceBase5: base5,
            invoicePorIva6: por6,
            invoiceCuotaIva6: cuota6,
            invoiceBase6: base6
          }
        });

      } else {

        var valorDespuesDeMeterNif = undefined;

        if (typeof (this.formulario.get('imponibles').get('invoicePorIva1').value) === "string") {
          valorDespuesDeMeterNif = this.getAmountValue(this.formulario.get('imponibles').get('invoicePorIva1').value);
        } else {
          valorDespuesDeMeterNif = this.formulario.get('imponibles').get('invoicePorIva1').value;
        }

        if (valorDespuesDeMeterNif) {

          let porIva = valorDespuesDeMeterNif;
          let base = Number(this.redondearExp(totalFactura, 2)) / (1 + (valorDespuesDeMeterNif / 100));
          base = Number(this.redondearExp(base, 2));
          let cuota = totalFactura - base;
          cuota = Number(this.redondearExp(cuota, 2));

          this.formulario.patchValue({
            imponibles: {
              invoiceBase1: this.redondearExp(base, 2),
              invoicePorIva1: this.redondearExp(porIva, 2),
              invoiceCuotaIva1: this.redondearExp(cuota, 2)
            }
          });

          ///////////////////////////////////////
          //Se limpian las bases a causa de nuevo total

          base2 = undefined;
          por2 = undefined;
          cuota2 = undefined;
          base3 = undefined;
          por3 = undefined;
          cuota3 = undefined;
          base4 = undefined;
          por4 = undefined;
          cuota4 = undefined;
          base5 = undefined;
          por5 = undefined;
          cuota5 = undefined;
          base6 = undefined;
          por6 = undefined;
          cuota6 = undefined;

          this.formulario.patchValue({
            imponibles: {
              invoicePorIva2: por2,
              invoiceCuotaIva2: cuota2,
              invoiceBase2: base2,
              invoicePorIva3: por3,
              invoiceCuotaIva3: cuota3,
              invoiceBase3: base3,
              invoicePorIva4: por4,
              invoiceCuotaIva4: cuota4,
              invoiceBase4: base4,
              invoicePorIva5: por5,
              invoiceCuotaIva5: cuota5,
              invoiceBase5: base5,
              invoicePorIva6: por6,
              invoiceCuotaIva6: cuota6,
              invoiceBase6: base6
            }
          });

        } else {

          let porIva = 21;
          let base = Number(this.redondearExp(totalFactura, 2)) / 1.21;
          base = Number(this.redondearExp(base, 2));
          let cuota = totalFactura - base;
          cuota = Number(this.redondearExp(cuota, 2));

          this.formulario.patchValue({
            imponibles: {
              invoiceBase1: this.redondearExp(base, 2),
              invoicePorIva1: this.redondearExp(porIva, 2),
              invoiceCuotaIva1: this.redondearExp(cuota, 2)
            }
          });

          ///////////////////////////////////////
          //Se limpian las bases a causa de nuevo total

          base2 = undefined;
          por2 = undefined;
          cuota2 = undefined;
          base3 = undefined;
          por3 = undefined;
          cuota3 = undefined;
          base4 = undefined;
          por4 = undefined;
          cuota4 = undefined;
          base5 = undefined;
          por5 = undefined;
          cuota5 = undefined;
          base6 = undefined;
          por6 = undefined;
          cuota6 = undefined;

          this.formulario.patchValue({
            imponibles: {
              invoicePorIva2: por2,
              invoiceCuotaIva2: cuota2,
              invoiceBase2: base2,
              invoicePorIva3: por3,
              invoiceCuotaIva3: cuota3,
              invoiceBase3: base3,
              invoicePorIva4: por4,
              invoiceCuotaIva4: cuota4,
              invoiceBase4: base4,
              invoicePorIva5: por5,
              invoiceCuotaIva5: cuota5,
              invoiceBase5: base5,
              invoicePorIva6: por6,
              invoiceCuotaIva6: cuota6,
              invoiceBase6: base6
            }
          });
        }
      }
    }
  }

  retencionChange() {
    let baseRetencion: number = this.DevolverValorCeldaNumber('invoiceBaseRetencion', "retenciones");
    let porRetencion: number = this.DevolverValorCeldaNumber('invoicePorRetencion', "retenciones");
    let cuotaRetencion: number = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");
    let tipoRetencion: number = this.DevolverValorCeldaNumber('invoiceTipoRetencion', "retenciones");

    if (baseRetencion == 0) { //si borramos la base, la retención desaparece.
      porRetencion = 0;
      tipoRetencion = 0;
    }

    cuotaRetencion = this.redondearExp(baseRetencion * porRetencion / 100, 2);

    if (tipoRetencion == 0) {
      switch (porRetencion) {
        case 1: tipoRetencion = 5; //Modulos
          break;
        case 2: tipoRetencion = 4; //Agricultores
          break;
        case 7: tipoRetencion = 7; //Profesionales Reducida
          break;
        case 15: tipoRetencion = 1; //Profesionales
          break;
      }
    }

    this.formulario.patchValue({
      retenciones: {
        invoiceBaseRetencion: (baseRetencion == 0) ? undefined : baseRetencion,
        invoicePorRetencion: (porRetencion == 0) ? undefined : porRetencion,
        invoiceCuotaRetencion: (cuotaRetencion == 0) ? undefined : cuotaRetencion,
        invoiceTipoRetencion: (tipoRetencion == 0) ? '' : tipoRetencion,
      }
    });
  }

  changePorIva(value: string, index: number) {

    let baseIva: number = this.DevolverValorCeldaNumber('invoiceBase' + index.toString(), "imponibles");
    let porIva: number = this.DevolverValorCeldaNumber('invoicePorIva' + index.toString(), "imponibles");
    let porRecargo: number = this.DevolverValorCeldaNumber('invoicePorRecargo' + index.toString(), "imponibles");

    let cuota = Number(0);
    let cuotaRecargo = Number(0);

    cuota = this.redondearExp(baseIva * porIva / 100, 2);

    //Si tiene recargo ya metido, asignamos el recargo correspondiente al porcentaje de iva introducido.
    if (porRecargo != 0) {
      porRecargo = this.PorRecargoCorrespondiente(porIva);

      cuotaRecargo = this.redondearExp(baseIva * porRecargo / 100, 2);
    }

    switch (index) {
      case 1: this.formulario.patchValue({

        imponibles: {
          invoiceCuotaIva1: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo1: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo1: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 2: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaIva2: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo2: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo2: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 3: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaIva3: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo3: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo3: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 4: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaIva4: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo4: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo4: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 5: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaIva5: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo5: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo5: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 6: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaIva6: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo6: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo6: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
    }

    //Despues recalculamos el resto de bases y posibles retenciones.
    this.recalculoBasesRetencion(index);
  }

  PorRecargoCorrespondiente(porIva: number): number {
    let porRecargo = 0;

    switch (porIva) {
      case 21: porRecargo = 5.2;
        break;
      case 10: porRecargo = 1.4;
        break;
      case 7.5: porRecargo = 1;
        break;
      case 5: porRecargo = 0.62;
        break;
      case 4: porRecargo = 0.5;
        break;
      case 2: porRecargo = 0.26;
        break;
      case 0: porRecargo = 0;
        break;
      /////////////////////////////////////
      ///////////////////////////////////// CANARIAS IGIC
      case 20: porRecargo = 2;
        break;
      case 15: porRecargo = 1.35;
        break;
      case 9.5: porRecargo = 0.95;
        break;
      case 7: porRecargo = 0.7;
        break;
      case 3: porRecargo = 0.3;
        break;
      case 0: porRecargo = 0;
        break;
    }

    return porRecargo;
  }

  calculoParaCents(index: number, sumaCifras: number, tot: number) {

    var resultado = this.redondearExp(tot - sumaCifras, 2);
    var cuotaRet: number = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");

    if (resultado != 0) {

      if (cuotaRet != 0) {
        //Se resta el centimo en la cuota de retencion...
        cuotaRet = this.redondearExp(cuotaRet - resultado, 2);

        this.formulario.patchValue({
          retenciones: {
            invoiceCuotaRetencion: cuotaRet,
          }
        });

        return;
      }

      if ((resultado < 0 && resultado == -0.01) || (resultado > 0 && resultado == 0.01)) {

        switch (index) {
          case 1:

            var cuota = this.DevolverValorCeldaNumber('invoiceCuotaIva1', "imponibles");
            cuota = cuota + resultado;
            cuota = this.redondearExp(cuota, 2);

            this.formulario.patchValue({
              imponibles: {
                invoiceCuotaIva1: cuota,
              }
            });

            break;
          case 2:

            var cuota = this.DevolverValorCeldaNumber('invoiceCuotaIva2', "imponibles");
            cuota = cuota + resultado;
            cuota = this.redondearExp(cuota, 2);

            this.formulario.patchValue({
              imponibles: {
                invoiceCuotaIva2: cuota,
              }
            });

            break;
          case 3:

            var cuota = this.DevolverValorCeldaNumber('invoiceCuotaIva3', "imponibles");
            cuota = cuota + resultado;
            cuota = this.redondearExp(cuota, 2);

            this.formulario.patchValue({
              imponibles: {
                invoiceCuotaIva3: cuota,
              }
            });

            break;
          case 4:

            var cuota = this.DevolverValorCeldaNumber('invoiceCuotaIva4', "imponibles");
            cuota = cuota + resultado;
            cuota = this.redondearExp(cuota, 2);

            this.formulario.patchValue({
              imponibles: {
                invoiceCuotaIva4: cuota,
              }
            });

            break;
          case 5:

            var cuota = this.DevolverValorCeldaNumber('invoiceCuotaIva5', "imponibles");
            cuota = cuota + resultado;
            cuota = this.redondearExp(cuota, 2);

            this.formulario.patchValue({
              imponibles: {
                invoiceCuotaIva5: cuota,
              }
            });

            break;
        }
      }
    }
  }

  recalculoBasesRetencion(index: number) {

    ////////////////////////////////////////////////////////////
    //COMPROBAMOS si el cambio realizado ha sido de un centimo arriba / un centimo abajo:

    let tot: number = this.DevolverValorCeldaNumber('invoiceTotal', "");
    let suplid: number = this.DevolverValorCeldaNumber('invoiceSuplidos', "");
    let cuotaIva1: number = this.DevolverValorCeldaNumber('invoiceCuotaIva1', "imponibles");
    let cuotaIva2: number = this.DevolverValorCeldaNumber('invoiceCuotaIva2', "imponibles");
    let cuotaIva3: number = this.DevolverValorCeldaNumber('invoiceCuotaIva3', "imponibles");
    let cuotaIva4: number = this.DevolverValorCeldaNumber('invoiceCuotaIva4', "imponibles");
    let cuotaIva5: number = this.DevolverValorCeldaNumber('invoiceCuotaIva5', "imponibles");
    let cuotaIva6: number = this.DevolverValorCeldaNumber('invoiceCuotaIva6', "imponibles");
    let bse1: number = this.DevolverValorCeldaNumber('invoiceBase1', "imponibles");
    let bse2: number = this.DevolverValorCeldaNumber('invoiceBase2', "imponibles");
    let bse3: number = this.DevolverValorCeldaNumber('invoiceBase3', "imponibles");
    let bse4: number = this.DevolverValorCeldaNumber('invoiceBase4', "imponibles");
    let bse5: number = this.DevolverValorCeldaNumber('invoiceBase5', "imponibles");
    let bse6: number = this.DevolverValorCeldaNumber('invoiceBase6', "imponibles");
    let rec1: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo1', "imponibles");
    let rec2: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo2', "imponibles");
    let rec3: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo3', "imponibles");
    let rec4: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo4', "imponibles");
    let rec5: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo5', "imponibles");
    let rec6: number = this.DevolverValorCeldaNumber('invoiceCuotaRecargo6', "imponibles");
    let cuotaRet: number = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");
    const tipoDeFacturaSelecc = parseInt(this.formulario.get('invoiceTipoFactura').value);

    let sumaParaCalculo = Number(0);
    let sumaBases = Number(0);
    let sumaCuotas = Number(0);
    let sumaRecargos = Number(0);

    sumaCuotas = (cuotaIva1 + cuotaIva2 + cuotaIva3 + cuotaIva4 + cuotaIva5 + cuotaIva6);
    sumaBases = (bse1 + bse2 + bse3 + bse4 + bse5 + bse6);
    sumaRecargos = (rec1 + rec2 + rec3 + rec4 + rec5 + rec6);

    //Es recibida e "Inversión en sujeto pasivo"...
    if (this.document.tipoDocumento == 2 && (tipoDeFacturaSelecc == 8 || tipoDeFacturaSelecc == 9)) {

      if (tot != sumaBases) {
        //HACER AJUSTE
        this.calculoParaCents(index, sumaBases, tot);
      }
    }

    //Operacion interior, Operacion interior (bien inversion),
    if (tipoDeFacturaSelecc == 1 || tipoDeFacturaSelecc == 4 || tipoDeFacturaSelecc >= 7) {
      sumaParaCalculo = sumaBases + sumaCuotas + sumaRecargos;
    }

    sumaParaCalculo = this.redondearExp(sumaParaCalculo - cuotaRet + suplid, 2);
    //sumaParaCalculo = (sumaParaCalculo - cuotaRet) + suplid;

    if (tot != sumaParaCalculo) {
      //HACER AJUSTE
      this.calculoParaCents(index, sumaParaCalculo, tot);
    }

    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////

    tot = this.DevolverValorCeldaNumber('invoiceTotal', "");
    suplid = this.DevolverValorCeldaNumber('invoiceSuplidos', "");
    cuotaIva1 = this.DevolverValorCeldaNumber('invoiceCuotaIva1', "imponibles");
    cuotaIva2 = this.DevolverValorCeldaNumber('invoiceCuotaIva2', "imponibles");
    cuotaIva3 = this.DevolverValorCeldaNumber('invoiceCuotaIva3', "imponibles");
    cuotaIva4 = this.DevolverValorCeldaNumber('invoiceCuotaIva4', "imponibles");
    cuotaIva5 = this.DevolverValorCeldaNumber('invoiceCuotaIva5', "imponibles");
    cuotaIva6 = this.DevolverValorCeldaNumber('invoiceCuotaIva6', "imponibles");
    bse1 = this.DevolverValorCeldaNumber('invoiceBase1', "imponibles");
    bse2 = this.DevolverValorCeldaNumber('invoiceBase2', "imponibles");
    bse3 = this.DevolverValorCeldaNumber('invoiceBase3', "imponibles");
    bse4 = this.DevolverValorCeldaNumber('invoiceBase4', "imponibles");
    bse5 = this.DevolverValorCeldaNumber('invoiceBase5', "imponibles");
    bse6 = this.DevolverValorCeldaNumber('invoiceBase6', "imponibles");
    rec1 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo1', "imponibles");
    rec2 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo2', "imponibles");
    rec3 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo3', "imponibles");
    rec4 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo4', "imponibles");
    rec5 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo5', "imponibles");
    rec6 = this.DevolverValorCeldaNumber('invoiceCuotaRecargo6', "imponibles");
    cuotaRet = this.DevolverValorCeldaNumber('invoiceCuotaRetencion', "retenciones");


    //Inicializamos siempre las casillas de retención.
    this.formulario.patchValue({
      retenciones: {
        invoiceBaseRetencion: undefined,
        invoicePorRetencion: undefined,
        invoiceCuotaRetencion: undefined
      }
    });

    let bases: Array<number> = [0, 0, 0, 0, 0, 0];
    let porIva: Array<number> = [0, 0, 0, 0, 0, 0];
    let cuotasIva: Array<number> = [0, 0, 0, 0, 0, 0];
    let porRecargo: Array<number> = [0, 0, 0, 0, 0, 0];
    let cuotasRecargo: Array<number> = [0, 0, 0, 0, 0, 0];

    //Inicializamos siempre las casillas de bases e ivas a partir de donde estamos calculando.
    for (var i = index + 1; i < 7; i++) {
      switch (i) {
        case 2: this.formulario.patchValue({
          imponibles: {
            invoiceBase2: (bases[i - 1] == 0) ? undefined : bases[i - 1],
            invoiceCuotaIva2: (cuotasIva[i - 1] == 0) ? undefined : cuotasIva[i - 1],
            invoicePorIva2: (porIva[i - 1] == 0) ? undefined : porIva[i - 1],
            invoicePorRecargo2: (porRecargo[i - 1] == 0) ? undefined : porRecargo[i - 1],
            invoiceCuotaRecargo2: (cuotasRecargo[i - 1] == 0) ? undefined : cuotasRecargo[i - 1]
          }
        });
          break;
        case 3: this.formulario.patchValue({
          imponibles: {
            invoiceBase3: (bases[i - 1] == 0) ? undefined : bases[i - 1],
            invoiceCuotaIva3: (cuotasIva[i - 1] == 0) ? undefined : cuotasIva[i - 1],
            invoicePorIva3: (porIva[i - 1] == 0) ? undefined : porIva[i - 1],
            invoicePorRecargo3: (porRecargo[i - 1] == 0) ? undefined : porRecargo[i - 1],
            invoiceCuotaRecargo3: (cuotasRecargo[i - 1] == 0) ? undefined : cuotasRecargo[i - 1]
          }
        });
          break;
        case 4: this.formulario.patchValue({
          imponibles: {
            invoiceBase4: (bases[i - 1] == 0) ? undefined : bases[i - 1],
            invoiceCuotaIva4: (cuotasIva[i - 1] == 0) ? undefined : cuotasIva[i - 1],
            invoicePorIva4: (porIva[i - 1] == 0) ? undefined : porIva[i - 1],
            invoicePorRecargo4: (porRecargo[i - 1] == 0) ? undefined : porRecargo[i - 1],
            invoiceCuotaRecargo4: (cuotasRecargo[i - 1] == 0) ? undefined : cuotasRecargo[i - 1]
          }
        });
          break;
        case 5: this.formulario.patchValue({
          imponibles: {
            invoiceBase5: (bases[i - 1] == 0) ? undefined : bases[i - 1],
            invoiceCuotaIva5: (cuotasIva[i - 1] == 0) ? undefined : cuotasIva[i - 1],
            invoicePorIva5: (porIva[i - 1] == 0) ? undefined : porIva[i - 1],
            invoicePorRecargo5: (porRecargo[i - 1] == 0) ? undefined : porRecargo[i - 1],
            invoiceCuotaRecargo5: (cuotasRecargo[i - 1] == 0) ? undefined : cuotasRecargo[i - 1]
          }
        });
          break;
        case 6: this.formulario.patchValue({
          imponibles: {
            invoiceBase6: (bases[i - 1] == 0) ? undefined : bases[i - 1],
            invoiceCuotaIva6: (cuotasIva[i - 1] == 0) ? undefined : cuotasIva[i - 1],
            invoicePorIva6: (porIva[i - 1] == 0) ? undefined : porIva[i - 1],
            invoicePorRecargo6: (porRecargo[i - 1] == 0) ? undefined : porRecargo[i - 1],
            invoiceCuotaRecargo6: (cuotasRecargo[i - 1] == 0) ? undefined : cuotasRecargo[i - 1]
          }
        });
          break;
      }
    }

    for (var i = 1; i < 7; i++) {
      bases[i - 1] = this.DevolverValorCeldaNumber('invoiceBase' + i.toString(), "imponibles");
      porIva[i - 1] = this.DevolverValorCeldaNumber('invoicePorIva' + i.toString(), "imponibles");
      cuotasIva[i - 1] = this.DevolverValorCeldaNumber('invoiceCuotaIva' + i.toString(), "imponibles");
      porRecargo[i - 1] = this.DevolverValorCeldaNumber('invoicePorRecargo' + i.toString(), "imponibles");
      cuotasRecargo[i - 1] = this.DevolverValorCeldaNumber('invoiceCuotaRecargo' + i.toString(), "imponibles");
    }

    let restoRepartir = Number(tot);

    restoRepartir = this.redondearExp(restoRepartir - suplid, 2);

    for (var i = 0; i < index; i++) {
      restoRepartir = this.redondearExp(restoRepartir - bases[i] - cuotasIva[i] - cuotasRecargo[i], 2);
    }

    //Si es 0 o es igual al monto INICIAL del total, no hacemos nada...
    if (restoRepartir == 0 || restoRepartir == tot) {
      return;
    }

    if (restoRepartir > 0) {
      let porIvaPosicion = Number(0);
      let porRecargoPosicion = Number(0);

      let ivaToca = this.SacarIvasLinea(bases, porIva, porRecargo, index);

      if (ivaToca) {
        porIvaPosicion = ivaToca[0];
        porRecargoPosicion = ivaToca[1];
      }

      let cuotaPosicion = Number(0);
      let cuotaRecargoPosicion = Number(0);
      let basePosicion = Number(0);

      basePosicion = this.redondearExp(restoRepartir / (1 + ((porIvaPosicion + porRecargoPosicion) / 100)), 2);
      cuotaPosicion = this.redondearExp(restoRepartir - basePosicion, 2);

      if (porRecargoPosicion != 0) {
        cuotaRecargoPosicion = this.redondearExp(basePosicion * porRecargoPosicion / 100, 2);
        cuotaPosicion = this.redondearExp(cuotaPosicion - cuotaRecargoPosicion, 2);
      }

      if (index < 6) {
        switch (index) {
          case 1: this.formulario.patchValue({
            imponibles: {
              invoiceBase2: (basePosicion == 0) ? undefined : basePosicion,
              invoiceCuotaIva2: (cuotaPosicion == 0) ? undefined : cuotaPosicion,
              invoicePorIva2: (porIvaPosicion == 0) ? undefined : porIvaPosicion,
              invoicePorRecargo2: (porRecargoPosicion == 0) ? undefined : porRecargoPosicion,
              invoiceCuotaRecargo2: (cuotaRecargoPosicion == 0) ? undefined : cuotaRecargoPosicion
            }
          });
            break;
          case 2: this.formulario.patchValue({
            imponibles: {
              invoiceBase3: (basePosicion == 0) ? undefined : basePosicion,
              invoiceCuotaIva3: (cuotaPosicion == 0) ? undefined : cuotaPosicion,
              invoicePorIva3: (porIvaPosicion == 0) ? undefined : porIvaPosicion,
              invoicePorRecargo3: (porRecargoPosicion == 0) ? undefined : porRecargoPosicion,
              invoiceCuotaRecargo3: (cuotaRecargoPosicion == 0) ? undefined : cuotaRecargoPosicion
            }
          });
            break;
          case 3: this.formulario.patchValue({
            imponibles: {
              invoiceBase4: (basePosicion == 0) ? undefined : basePosicion,
              invoiceCuotaIva4: (cuotaPosicion == 0) ? undefined : cuotaPosicion,
              invoicePorIva4: (porIvaPosicion == 0) ? undefined : porIvaPosicion,
              invoicePorRecargo4: (porRecargoPosicion == 0) ? undefined : porRecargoPosicion,
              invoiceCuotaRecargo4: (cuotaRecargoPosicion == 0) ? undefined : cuotaRecargoPosicion
            }
          });
            break;
          case 4: this.formulario.patchValue({
            imponibles: {
              invoiceBase5: (basePosicion == 0) ? undefined : basePosicion,
              invoiceCuotaIva5: (cuotaPosicion == 0) ? undefined : cuotaPosicion,
              invoicePorIva5: (porIvaPosicion == 0) ? undefined : porIvaPosicion,
              invoicePorRecargo5: (porRecargoPosicion == 0) ? undefined : porRecargoPosicion,
              invoiceCuotaRecargo5: (cuotaRecargoPosicion == 0) ? undefined : cuotaRecargoPosicion
            }
          });
            break;
          case 5: this.formulario.patchValue({
            imponibles: {
              invoiceBase6: (basePosicion == 0) ? undefined : basePosicion,
              invoiceCuotaIva6: (cuotaPosicion == 0) ? undefined : cuotaPosicion,
              invoicePorIva6: (porIvaPosicion == 0) ? undefined : porIvaPosicion,
              invoicePorRecargo6: (porRecargoPosicion == 0) ? undefined : porRecargoPosicion,
              invoiceCuotaRecargo6: (cuotaRecargoPosicion == 0) ? undefined : cuotaRecargoPosicion
            }
          });
            break;
        }
      }
    } else {
      let sumaCuotas = Number(0);
      let baseRetencion = Number(0);
      let cuotaRetencion = Number(0);
      let porRetencion = Number(0);

      for (i = 0; i < 6; i++) {
        baseRetencion = baseRetencion + bases[i];
        sumaCuotas = sumaCuotas + cuotasIva[i] + cuotasRecargo[i];
      }

      baseRetencion = this.redondearExp(baseRetencion, 2);
      sumaCuotas = this.redondearExp(sumaCuotas, 2);

      cuotaRetencion = this.redondearExp(restoRepartir * -1, 2);

      porRetencion = this.redondearExp(cuotaRetencion * 100 / baseRetencion, 2);

      this.formulario.patchValue({
        retenciones: {
          invoiceBaseRetencion: (baseRetencion == 0) ? undefined : baseRetencion,
          invoicePorRetencion: (porRetencion == 0) ? undefined : porRetencion,
          invoiceCuotaRetencion: (cuotaRetencion == 0) ? undefined : cuotaRetencion,
        }
      });
    }
  }

  SacarIvasLinea(bases: number[], porIva: number[], porRecargo: number[], index: number): number[] {
    let result = new Array(0, 0);

    let existenIva: Array<boolean> = [false, false, false, false, false, false, false];
    let ivasDefecto: Array<number> = [21, 10, 7.5, 5, 4, 2, 0];
    let recargoDefecto: Array<number> = [5.2, 1.4, 1, 0.62, 0.5, 0.26, 0];
    let totalIvas = 6;

    if (this.esEmpresaDeCanarias == true) {
      ivasDefecto = new Array(0, 3, 7, 9.5, 15, 20);
      recargoDefecto = new Array(0, 0.3, 0.7, 0.95, 1.35, 2);
    }

    let tieneRecargo = false;

    for (var i = 0; i < index; i++) {
      if (porRecargo[i] != 0) {
        tieneRecargo = true;
      }
    }

    if (tieneRecargo == false) {
      for (var i = 0; i < totalIvas; i++) {
        recargoDefecto[i] = 0;
      }
    }

    for (var i = 0; i < index; i++) {
      if (bases[i] != 0) {
        for (var j = 0; j < totalIvas; j++) {
          if (porIva[i] == ivasDefecto[j]) {
            existenIva[j] = true;
          }
        }
      }
    }

    let asignado = false;
    let porIvaPosicion = Number(0);
    let porRecargoPosicion = Number(0);

    existenIva.forEach((element, index) => {
      if (element == false && asignado == false) {
        porIvaPosicion = ivasDefecto[index];
        porRecargoPosicion = recargoDefecto[index];
        asignado = true;
      }
    });

    result[0] = porIvaPosicion;
    result[1] = porRecargoPosicion;

    return result;
  }

  changePorRecargo(valor: any, recargoNumber: number) {

    let baseIva: number = this.DevolverValorCeldaNumber('invoiceBase' + recargoNumber.toString(), "imponibles");
    let porRecargo: number = this.DevolverValorCeldaNumber('invoicePorRecargo' + recargoNumber.toString(), "imponibles");

    let cuotaRecargo = Number(0);

    cuotaRecargo = this.redondearExp(baseIva * porRecargo / 100, 2);

    switch (recargoNumber) {
      case 1: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo1: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 2: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo2: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 3: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo3: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 4: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo4: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 5: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo5: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 6: this.formulario.patchValue({
        imponibles: {
          invoiceCuotaRecargo6: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
    }

    //Despues recalculamos el resto de bases y posibles retenciones.
    this.recalculoBasesRetencion(recargoNumber);
  }

  baseChange(val: any, baseNumber: number) {

    let totalFactura: number = this.DevolverValorCeldaNumber('invoiceTotal', "");
    let baseIva: number = this.DevolverValorCeldaNumber('invoiceBase' + baseNumber.toString(), "imponibles");
    let porIva: number = this.DevolverValorCeldaNumber('invoicePorIva' + baseNumber.toString(), "imponibles");
    let porRecargo = this.DevolverValorCeldaNumber('invoicePorRecargo' + baseNumber.toString(), "imponibles");
    let cuota: number = Number(0);
    let cuotaRecargo: number = Number(0);

    /////////////////////////////////////////////////////////////
    //Se eliminan bases inferiores y actual en caso de borrado...
    switch (baseNumber) {
      case 1:
        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base1
              invoicePorIva1: undefined,
              invoiceCuotaIva1: undefined,
              invoicePorRecargo1: undefined,
              invoiceCuotaRecargo1: undefined,
              //base2
              invoiceBase2: undefined,
              invoicePorIva2: undefined,
              invoiceCuotaIva2: undefined,
              invoicePorRecargo2: undefined,
              invoiceCuotaRecargo2: undefined,
              //base3
              invoiceBase3: undefined,
              invoicePorIva3: undefined,
              invoiceCuotaIva3: undefined,
              invoicePorRecargo3: undefined,
              invoiceCuotaRecargo3: undefined,
              //base4
              invoiceBase4: undefined,
              invoicePorIva4: undefined,
              invoiceCuotaIva4: undefined,
              invoicePorRecargo4: undefined,
              invoiceCuotaRecargo4: undefined,
              //base5
              invoiceBase5: undefined,
              invoicePorIva5: undefined,
              invoiceCuotaIva5: undefined,
              invoicePorRecargo5: undefined,
              invoiceCuotaRecargo5: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }

        break;
      case 2:

        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base2
              invoicePorIva2: undefined,
              invoiceCuotaIva2: undefined,
              invoicePorRecargo2: undefined,
              invoiceCuotaRecargo2: undefined,
              //base3
              invoiceBase3: undefined,
              invoicePorIva3: undefined,
              invoiceCuotaIva3: undefined,
              invoicePorRecargo3: undefined,
              invoiceCuotaRecargo3: undefined,
              //base4
              invoiceBase4: undefined,
              invoicePorIva4: undefined,
              invoiceCuotaIva4: undefined,
              invoicePorRecargo4: undefined,
              invoiceCuotaRecargo4: undefined,
              //base5
              invoiceBase5: undefined,
              invoicePorIva5: undefined,
              invoiceCuotaIva5: undefined,
              invoicePorRecargo5: undefined,
              invoiceCuotaRecargo5: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }


        break;
      case 3:

        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base3
              invoicePorIva3: undefined,
              invoiceCuotaIva3: undefined,
              invoicePorRecargo3: undefined,
              invoiceCuotaRecargo3: undefined,
              //base4
              invoiceBase4: undefined,
              invoicePorIva4: undefined,
              invoiceCuotaIva4: undefined,
              invoicePorRecargo4: undefined,
              invoiceCuotaRecargo4: undefined,
              //base5
              invoiceBase5: undefined,
              invoicePorIva5: undefined,
              invoiceCuotaIva5: undefined,
              invoicePorRecargo5: undefined,
              invoiceCuotaRecargo5: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }

        break;
      case 4:

        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base4
              invoicePorIva4: undefined,
              invoiceCuotaIva4: undefined,
              invoicePorRecargo4: undefined,
              invoiceCuotaRecargo4: undefined,
              //base5
              invoiceBase5: undefined,
              invoicePorIva5: undefined,
              invoiceCuotaIva5: undefined,
              invoicePorRecargo5: undefined,
              invoiceCuotaRecargo5: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }

        break;
      case 5:

        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base5
              invoiceBase5: undefined,
              invoicePorIva5: undefined,
              invoiceCuotaIva5: undefined,
              invoicePorRecargo5: undefined,
              invoiceCuotaRecargo5: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }

        break;
      case 6:

        if (baseIva == 0) {
          this.formulario.patchValue({
            imponibles: {
              //base6
              invoiceBase6: undefined,
              invoicePorIva6: undefined,
              invoiceCuotaIva6: undefined,
              invoicePorRecargo6: undefined,
              invoiceCuotaRecargo6: undefined
            },
            retenciones: {
              invoiceBaseRetencion: undefined,
              invoicePorRetencion: undefined,
              invoiceCuotaRetencion: undefined,
              invoiceTipoRetencion: undefined,
            }
          });

          return;
        }

        break;
    };

    /////////////////////////////////////////////////////////////////////
    //Si no ha sido eliminada ninguna base, se continua con el cálculo...

    //////////////////////////////////////////////////////
    //Si la base imponible 1 = total...
    if (baseNumber == 1 && baseIva == totalFactura) {
      this.formulario.patchValue({
        imponibles: {
          invoicePorIva1: undefined,
          invoiceCuotaIva1: undefined,
          invoicePorRecargo1: undefined,
          invoiceCuotaRecargo1: undefined
        }
      });

      this.recalculoBasesRetencion(baseNumber);

      return;
    }

    if (baseIva == 0) {
      porIva = 0;
      porRecargo = 0;
    }

    let arrayBases: Array<number> = [0, 0, 0, 0, 0, 0];
    let arrayPorIva: Array<number> = [0, 0, 0, 0, 0, 0];
    let arrayPorRecargo: Array<number> = [0, 0, 0, 0, 0, 0];

    for (var i = 1; i < 7; i++) {
      arrayBases[i - 1] = this.DevolverValorCeldaNumber('invoiceBase' + i.toString(), "imponibles");
      arrayPorIva[i - 1] = this.DevolverValorCeldaNumber('invoicePorIva' + i.toString(), "imponibles");
      arrayPorRecargo[i - 1] = this.DevolverValorCeldaNumber('invoicePorRecargo' + i.toString(), "imponibles");
    }

    if (baseIva != 0 && porIva == 0) {

      let ivaToca = this.SacarIvasLinea(arrayBases, arrayPorIva, arrayPorRecargo, baseNumber);

      if (ivaToca) {
        porIva = ivaToca[0];
        porRecargo = ivaToca[1];
      }
    } else if (baseNumber > 1 && (baseIva != 0 && arrayPorRecargo[baseNumber - 2] != 0)) {
      porRecargo = this.PorRecargoCorrespondiente(porIva);
    }

    cuota = this.redondearExp(baseIva * porIva / 100, 2);
    var valueCuotaVieja: number = this.formulario.get("imponibles").get("invoiceCuotaIva" + baseNumber).value
    var resultDiff = valueCuotaVieja - cuota;

    if (resultDiff == -0.01 || resultDiff == 0.01) {
      cuota = valueCuotaVieja;
    }

    cuotaRecargo = this.redondearExp(baseIva * porRecargo / 100, 2);

    switch (baseNumber) {
      case 1:
        this.formulario.patchValue({
          imponibles: {
            invoiceBase1: (baseIva == 0) ? undefined : baseIva,
            invoicePorIva1: (porIva == 0) ? undefined : porIva,
            invoiceCuotaIva1: (cuota == 0) ? undefined : cuota,
            invoicePorRecargo1: (porRecargo == 0) ? undefined : porRecargo,
            invoiceCuotaRecargo1: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
          }
        });
        break;
      case 2: this.formulario.patchValue({
        imponibles: {
          invoiceBase2: (baseIva == 0) ? undefined : baseIva,
          invoicePorIva2: (porIva == 0) ? undefined : porIva,
          invoiceCuotaIva2: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo2: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo2: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 3: this.formulario.patchValue({
        imponibles: {
          invoiceBase3: (baseIva == 0) ? undefined : baseIva,
          invoicePorIva3: (porIva == 0) ? undefined : porIva,
          invoiceCuotaIva3: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo3: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo3: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 4: this.formulario.patchValue({
        imponibles: {
          invoiceBase4: (baseIva == 0) ? undefined : baseIva,
          invoicePorIva4: (porIva == 0) ? undefined : porIva,
          invoiceCuotaIva4: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo4: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo4: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 5: this.formulario.patchValue({
        imponibles: {
          invoiceBase5: (baseIva == 0) ? undefined : baseIva,
          invoicePorIva5: (porIva == 0) ? undefined : porIva,
          invoiceCuotaIva5: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo5: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo5: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
      case 6: this.formulario.patchValue({
        imponibles: {
          invoiceBase6: (baseIva == 0) ? undefined : baseIva,
          invoicePorIva6: (porIva == 0) ? undefined : porIva,
          invoiceCuotaIva6: (cuota == 0) ? undefined : cuota,
          invoicePorRecargo6: (porRecargo == 0) ? undefined : porRecargo,
          invoiceCuotaRecargo6: (cuotaRecargo == 0) ? undefined : cuotaRecargo,
        }
      });
        break;
    }

    //Despues recalculamos el resto de bases y posibles retenciones.
    this.recalculoBasesRetencion(baseNumber);
  }

  cuotaChange(cuotaNumber: number) {
    this.recalculoBasesRetencion(cuotaNumber);
    return;
  }

  GenerarPlantillaConNIF() {

    var cadena: string = (this.document.tipoDocumento == 1) ? this.document.secundario : this.formulario.get('invoiceCIF').value;

    var quieroPlantilla: any = {
      nifSecundario: cadena,
      tipo: this.document.tipoDocumento
    };

    this.router.navigate(['/Templates/', quieroPlantilla]);
  }

  ticketChange() {

    console.log(this.DevolverValorCeldaBoolean('invoiceEsTicket'));

    if (this.DevolverValorCeldaBoolean('invoiceEsTicket') == true) {

      //Inicializar todas las casillas de bases y cuotas.
      this.inicializarBasesCuotas();

      const totalFactura = this.DevolverValorCeldaNumber('invoiceTotal', "");

      this.formulario.patchValue({
        imponibles: {
          invoiceBase1: (totalFactura == 0) ? undefined : totalFactura
        }
      });

    } else {

      this.totalChange(this._valorTotalFactura);

    }
  }

  clickCheckIncidencia() {

    //Pasar por todos los checks de la pantalla para ver si
    var idFinalMarcado: number = 0;
    var textoObservaciones: string = "";
    let datoIncidenciaModal: any = {};
    var textoOriginal = (this.ObservacionCLIENTE == null) ? "" : this.ObservacionCLIENTE;

    this.tiposDeIncidencias.forEach(element => {
      textoOriginal = textoOriginal.replace(element.value.toUpperCase(), "");

      if (this.IDincidenciaPorModal > 0 && element.idInterno == this.IDincidenciaPorModal) {

        datoIncidenciaModal = element;

      }
      // else if (this.IDincidenciaPorModal == 0) {

      //   // textoOriginal = "";
      // }
    });

    textoOriginal = textoOriginal.replace("NO ES UNA FACTURA", "");
    textoOriginal = textoOriginal.replace("SIN NIF CLIENTE o PROVEEDOR", "");
    textoOriginal = textoOriginal.replace("FACTURA INCOMPLETA", "");
    textoOriginal = textoOriginal.replace("REVISAR IMPORTES", "");
    textoOriginal = textoOriginal.replace("REVISAR NUMERO DE FACTURA", "");
    textoOriginal = textoOriginal.replace("NO ES POSIBLE IDENTIFICAR LA FECHA DE LA FACTURA", "");
    textoOriginal = textoOriginal.replace("NO ES POSIBLE IDENTIFICAR EL CLIENTE O PROVEEDOR DE LA FACTURA", "");
    textoOriginal = textoOriginal.replace("REVISAR TIPO DE FACTURA", "");
    textoOriginal = textoOriginal.replace("IMPORTES EN UNA MONEDA DIFERENTE AL EURO", "");
    textoOriginal = textoOriginal.replace(" | ", "");

    //Comprobamos si en las observaciones venían comentarios de cliente, si es así, se pone el ID incidencia 50.
    if (textoOriginal.length > 0) {
      idFinalMarcado = 50;
    }

    if (this.IDincidenciaPorModal > 0) {

      //Se pone incidencia mas restrictiva...
      if (this.IDincidenciaPorModal > idFinalMarcado) {

        idFinalMarcado = this.IDincidenciaPorModal;
      }

      if (datoIncidenciaModal) {
        if (datoIncidenciaModal.id == 7) {
          textoObservaciones = this.IncidenciaAREA.toLocaleUpperCase();
        } else {
          textoObservaciones = datoIncidenciaModal.value.toUpperCase();
        }
      }
    }

    if (this.formChecksIncidencias.value["checkNoFactura"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "NO ES UNA FACTURA";
      if (idFinalMarcado < 100) {
        idFinalMarcado = 100;
      }
    }

    if (this.formChecksIncidencias.value["checkSinNif"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "SIN NIF CLIENTE o PROVEEDOR";
      if (idFinalMarcado < 12) {
        idFinalMarcado = 12;
      }
    }

    if (this.formChecksIncidencias.value["checkFacturaIncompleta"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "FACTURA INCOMPLETA";
      this.borrarDatosEnFacturaIncompleta();
      if (idFinalMarcado < 4) {
        idFinalMarcado = 4;
      }
    }

    if (this.formChecksIncidencias.value["checkRevisarImportes"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "REVISAR IMPORTES";
      if (idFinalMarcado < 13) {
        idFinalMarcado = 13;
      }
    }

    if (this.formChecksIncidencias.value["checkRevisarNumFact"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "REVISAR NUMERO DE FACTURA";
      if (idFinalMarcado < 9) {
        idFinalMarcado = 9;
      }
    }

    if (this.formChecksIncidencias.value["checkRevisarFecha"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "NO ES POSIBLE IDENTIFICAR LA FECHA DE LA FACTURA";
      if (idFinalMarcado < 11) {
        idFinalMarcado = 11;
      }
    }

    if (this.formChecksIncidencias.value["checkNoIdentClienteProveedor"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "NO ES POSIBLE IDENTIFICAR EL CLIENTE O PROVEEDOR DE LA FACTURA";
      if (idFinalMarcado < 4) {
        idFinalMarcado = 4;
      }
    }

    if (this.formChecksIncidencias.value["checkRevisarTipoFactura"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "REVISAR TIPO DE FACTURA";
      if (idFinalMarcado < 19) {
        idFinalMarcado = 19;
      }
    }

    if (this.formChecksIncidencias.value["checkNoEuro"] == true) {
      if (textoObservaciones.length > 0) { textoObservaciones = textoObservaciones + " | "; }
      textoObservaciones = textoObservaciones + "IMPORTES EN UNA MONEDA DIFERENTE AL EURO";
      if (idFinalMarcado < 20) {
        idFinalMarcado = 20;
      }
    }

    this.idTipoIncidencia = idFinalMarcado;

    this.ObservacionCLIENTE = textoOriginal;

    if (this.ObservacionCLIENTE.length > 0 && textoObservaciones.length > 0) { textoOriginal = textoOriginal + " | "; }
    this.ObservacionCLIENTE = textoOriginal + textoObservaciones;
  }

  CambiarFiltroTipoDocsRecargaUsers($event: any) {

    var valEvent = $event.target.options.selectedIndex;
    if (valEvent == 0) {
      this.filtroTipo = 1;
    }
    if (valEvent == 1) {
      this.filtroTipo = 2;
    }
    if (valEvent == 2) {
      this.filtroTipo = 3;
    }

    this.listafiltroNextUSUARIOS = [];
    var valorVacio: ListaFiltroSecunPrin = {
      secunPrin: "",
      fecha: 0,
      hora: 0
    };
    this.listafiltroNextUSUARIOS.push(valorVacio);

    combineLatest([
      this.invoiceService.CargarListadoSecundariosPendientes(this.filtroTipo, this.filtroEstado, "")
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          throw err;
        })),
      this.invoiceService.CargarListadoPrincipalesPendientes(this.filtroTipo, this.filtroEstado, "")
        .pipe(catchError(err => {
          console.warn("ERROR");
          console.warn(err);
          throw err;
        }))
    ]).subscribe(([secundarios, principales]) => {

      //console.clear();
      console.warn("Factura cargada con éxito.");

      secundarios.forEach(element => {
        this.listafiltroNextUSUARIOS.push(element);
      });

      principales.forEach(element => {
        this.listafiltroNextUSUARIOS.push(element);
      });

      this.listafiltroNextUSUARIOS = this.listafiltroNextUSUARIOS
        .sort(function (a, b) {

          if (b.fecha > a.fecha) { return -1; }
          if (b.fecha < a.fecha) { return 1; }
          //Ordenamos por hora
          if (b.fecha == a.fecha) {

            if (b.hora > a.hora) { return -1; }
            if (b.hora < a.hora) { return 1; }

            if (b.hora == a.hora) {

              return 0;
            }
          }
        });

      //Recarga get next...
      this.cambiarGetNext($event, false, true, false, false, false);

    }, error => {
      console.log(error);
      this.toastr.error('Error en carga axtualizada de usuarios en filtro segun tipo documento seleccionado...');
    });
  }

  cargarObservacionSecundario() {

    this.observacionSecundario = "";

    this.invoiceService.ObtenerObservacionSecundario(this.document.secundario, this.document.usuario)
      .subscribe(observacion => {

        if (observacion) {

          this.observacionSecundario = observacion.observacion;
          //Almacenaje temporal por si se cancela la edicion de la observacion...
          this.almacenarObservacionTemp = this.observacionSecundario;
        } else {
          this.observacionSecundario = "";
        }

      }, error => {
        console.log(error);
        this.toastr.error("Error al cargar la observación del usuario secundario");
        this.observacionSecundario = "";
      });
  }

  registrarObservacionSecundario() {
    console.log(this.observacionSecundario);

    var objeto: ObservacionesSecundario = {
      secundario: this.document.secundario,
      usuario: this.document.usuario,
      observacion: this.observacionSecundario
    };

    this.invoiceService.RegistrarObservacionSecundario(objeto).subscribe(resultado => {

      if (resultado == true) {
        this.toastr.success("Observación de secundario registrada");

        const botonModelObservacionSecun = document.getElementById("botonModelObservacionSecun") as HTMLElement;
        botonModelObservacionSecun.click();

      } else {
        this.toastr.error("No se ha podido registrar la observación del secundario.");

        const botonModelObservacionSecun = document.getElementById("botonModelObservacionSecun") as HTMLElement;
        botonModelObservacionSecun.click();
      }

    }, error => {
      console.log(error);
    })


  }


}
